import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import Dropzone from "../common/DropzoneExample";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import dayjs from "dayjs";
import CustomDropdown from "../common/CustomDropdown";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { FormCheck } from "react-bootstrap";
import SingleFileUpload from "../common/SingleDropzoneComponent";
import UserViewMembershipApplicationComponent from "./ViewUserMemberApplication";
import "react-phone-number-input/style.css";
import ReactPhoneInput from "react-phone-number-input";
import "./User-Member-application.css";
import Header from "./Header";
import { GetUserMemberApplicationData } from "../../components/UserMembershipApplication/Api/services/Webservices";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Footer from "./Footer";
import Datepicker from "../common/datepicker";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
// import { showToast, ToastMessage } from "../Shared/ToastMessage";
// import {useRazorpay} from 'react-razorpay';
import axios from "axios";
import Cookies from "js-cookie";

import {
  InsertUserDataOTP,
  VerifyUserDataOTP,
  ResendUserDataOTP,
  GetMemberInfo,
  InsertMembersPersonal,
  InsertMembersEducational,
  CheckUserDataUserDataApplication,
  DeleteOldMemberApplication,
  InsertMembersPaymentDetails,
} from "../../components/UserMembershipApplication/Api/services/Webservices";
import { useSettings } from "./SettingsContext";
import { last } from "pdf-lib";
import { decryptSlug, encryptSlug } from "../../util/encryption";

const UserMemberApplication = () => {
  const { razorpayKey } = useSettings();

  const history = useHistory();
  const { slug } = useParams();
  const decryptedId = decryptSlug(slug);
  const [data, setData] = useState([]);
  const [memberDetails, setMemberDetails] = useState({});
  // const applicationId = 1;

  const [eventType, seteventType] = useState("Add");
  const dateFormatList = "YYYY-MM-DD";

  const genderData = [
    {
      id: 1,
      value: "Male",
    },
    {
      id: 2,
      value: "Female",
    },
    {
      id: 3,
      value: "Others",
    },
  ];
  const salutationData = [
    {
      id: 1,
      value: "Dr.",
    },
    {
      id: 2,
      value: "Mr.",
    },
    {
      id: 3,
      value: "Mrs",
    },
    {
      id: 4,
      value: "Ms.",
    },
    {
      id: 5,
      value: "Prof",
    },
    {
      id: 6,
      value: "Surgeon",
    },
  ];

  const AllzoneData = [
    {
      id: 1,
      value: "South Zone",
      states: [
        "Andhra Pradesh",
        "Telangana",
        "Karnataka",
        "Tamil Nadu",
        "Kerala",
        "Puducherry", // UT
        "Lakshadweep", // UT
      ],
    },
    {
      id: 2,
      value: "North Zone",
      states: [
        "Jammu and Kashmir", // UT
        "Ladakh", // UT
        "Himachal Pradesh",
        "Punjab",
        "Haryana",
        "Delhi", // UT
        "Uttarakhand",
        "Uttar Pradesh",
        "Chandigarh", // UT
      ],
    },
    {
      id: 3,
      value: "East Zone",
      states: [
        "Bihar",
        "Jharkhand",
        "Odisha",
        "West Bengal",
        "Sikkim",
        "Assam",
        "Arunachal Pradesh",
        "Meghalaya",
        "Manipur",
        "Mizoram",
        "Nagaland",
        "Tripura",
      ],
    },
    {
      id: 4,
      value: "West Zone",
      states: [
        "Rajasthan",
        "Gujarat",
        "Goa",
        "Maharashtra",
        "Dadra and Nagar Haveli and Daman and Diu", // UT
      ],
    },
    {
      id: 5,
      value: "Central Zone",
      states: [
        "Madhya Pradesh",
        "Chhattisgarh",
        "Andaman and Nicobar Islands", // UT
      ],
    },
  ];

  const yearData = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  const organisationsData = ["SAGES", "ELSA", "Others"];
  const [isModalOpen, setModalOpen] = useState(false);
  const [userOTPid, setUserOTPid] = useState(null);
  const [storedOTP, setStoredOTP] = useState(null);
  const [applicationId, setApplicationID] = useState(null);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [action, setAction] = useState(null);
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);
  const [isLoadingPersonal, setIsLoadingPersonal] = useState(false);
  const [isLoadingEducation, setIsLoadingEducation] = useState(false);

  useEffect(() => {
    setApplicationID(parseInt(decryptedId));
  }, []);

  const [formValues, setFormValues] = useState({
    application_no: "",
    membership_no: "",
    salutation: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    mobile: "",
    mobile_code: "",
    father_name: "",
    dob: "",
    age: "",
    nationality: "Indian",
    // nationality:"",
    gender: "",
    street_line1: "",
    street_line2: "",
    country: 101,
    zone: "",
    // country:"",
    state: "",
    city: "",
    pin: "",
    landline: "",
    stdcode: "",
    mailing_address: 1,
    edu_undergrad_degree: "",
    edu_undergrad_college: "",
    edu_undergrad_university: "",
    edu_undergrad_year: "",
    edu_postgrad_degree: "",
    edu_postgrad_college: "",
    edu_postgrad_university: "",
    edu_postgrad_year: "",
    edu_superspecialty_degree: "",
    edu_superspecialty_college: "",
    edu_superspecialty_university: "",
    edu_superspecialty_year: "",
    mci_council_number: "",
    mci_council_state: "",
    imr_reg_no: "",
    asi_membership_no: "",
    asi_state: "",
    other_inter_organisation: [],
    other_inter_organisation_value: "",
  });

  const [errors, setErrors] = useState({
    profile: "",
    membership_no: "",
    first_name: "",
    // last_name: "",
    email: "",
    mobile: "",
    father_name: "",
    dob: "",
    age: "",
    zone: "",
    nationality: "",
    gender: "",
    street_line1: "",
    street_line2: "",
    country: "",
    state: "",
    city: "",
    pin: "",
    landline: "",
    stdcode: "",
    mailing_address: "",
    // edu_undergrad: "",
    // edu_postgrad: "",
    edu_undergrad_degree: "",
    edu_undergrad_college: "",
    edu_undergrad_university: "",
    edu_undergrad_year: "",
    edu_postgrad_degree: "",
    edu_postgrad_college: "",
    edu_postgrad_university: "",
    edu_postgrad_year: "",
    edu_superspecialty_degree: "",
    edu_superspecialty_college: "",
    edu_superspecialty_university: "",
    edu_superspecialty_year: "",
    mci_council_number: "",
    mci_council_state: "",
    imr_reg_no: "",
    asi_membership_no: "",
    asi_state: "",
    other_inter_organisation: "",
    mci_certificate: "",
    pg_degree_certificate: "",
    asi_member_certificate: "",
    active_license: "",
    letter_hod: "",
    mbbs_degree_certificate: "",
  });
  const scrollToFirstError = () => {
    setTimeout(() => {
      let element = document.querySelector(".red_border");

      // Special handling for phone input
      if (element && element.classList.contains("custom-phone-input")) {
        element = element.querySelector("input");
      }

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }, 100);
  };
  const DataRefechRetrigger = async (value) => {
    // const states = await fetchStateData(value);
    // setClinicStateData(states);
    // setRefechTrigger(data);
  };
  const calculateAge = (birthDate, currentDate = dayjs()) => {
    if (!birthDate) return "";

    const birth = dayjs(birthDate).startOf("day");
    const today = dayjs(currentDate).startOf("day");

    if (!birth.isValid() || !today.isValid()) return "";

    const age = today.diff(birth, "year");
    return age >= 0 ? age.toString() : "";
  };
  // const handleCountryChange = (countryCode) => {
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     countryCode: countryCode,
  //   }));
  // };

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const handleOtherOrganizationChange = (e, id) => {
    const isChecked = e.target.checked;
    setFormValues((prev) => {
      const updatedValues = prev.other_inter_organisation || [];
      return {
        ...prev,
        other_inter_organisation: isChecked
          ? [...updatedValues, id]
          : updatedValues.filter((org) => org !== id),
      };
    });
    if (id === "Others" && !isChecked) {
      formValues.other_inter_organisation_value = "";
    }
  };
  // ---------------Country Code ------------
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleMobileChange = (value) => {
    if (value) {
      setPhoneNumber(value);
      const phoneNumber = parsePhoneNumberFromString(value);
      if (phoneNumber) {
        const countryCode = `+${phoneNumber.countryCallingCode}`;
        const mobileNumber = phoneNumber.nationalNumber;
        // console.log(mobileNumber, "mobile");
        // console.log(countryCode, "country code");
        setFormValues({
          ...formValues,
          mobile: mobileNumber,
          mobile_code: countryCode,
        });
        return;
      }
    }
    setFormValues({
      ...formValues,
      mobile: "",
      mobile_code: "",
    });
  };

  //----------------- Profile ----------------
  const [profileFile, setProfileFile] = useState(null);
  const [profileFileError, setProfileFileError] = useState("");
  // const handleProfileFileUpload = (uploadedFile) => {
  //   setProfileFile(uploadedFile);
  //   console.log("Uploaded File:", uploadedFile);
  // };
  const [image, setImage] = useState("../../assets/images/user_image.png");
  const fileInputRef = useRef(null);
  const MAX_SIZE_MB = 2;
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
  const ALLOWED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "image/svg+xml",
  ];
  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setImage(null);
      setProfileFile(null);
      setErrors((prev) => ({ ...prev, profile: undefined }));
      return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        profile: "Only PNG, JPG, JPEG, WEBP, and SVG files are allowed.",
      }));
      event.target.value = "";
      return;
    }
    if (file.size > MAX_SIZE_BYTES) {
      setErrors((prev) => ({
        ...prev,
        profile: `File too large. Max ${MAX_SIZE_MB} MB`,
      }));
      event.target.value = "";
      return;
    }
    const imageUrl = URL.createObjectURL(file);
    setImage(imageUrl);
    setProfileFile(file);
    setErrors((prev) => ({ ...prev, profile: undefined }));
  };
  //-------------------------------------------------

  //----------------- MCI Certificate----------------
  const [mciCertificateFile, setMciCertificateFile] = useState(null);
  const [mciCertificateError, setMciCertificateError] = useState("");
  const handleMciCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, mci_certificate: uploadedFile });
    setMciCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- PG Degree Certificate----------------
  const [pgDegreeCertificateFile, setPgDegreeCertificateFile] = useState(null);
  const [pgDegreeCertificateError, setPgDegreeCertificateError] = useState("");
  const handlePgDegreeCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, pg_degree_certificate: uploadedFile });
    setPgDegreeCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- ASI Member Certificate----------------
  const [asiMemberCertificateFile, setAsiMemberCertificateFile] =
    useState(null);
  const [asiMemberCertificateError, setAsiMemberCertificateError] =
    useState("");
  const handleAsiMemberCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, asi_member_certificate: uploadedFile });
    setAsiMemberCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- Active License----------------
  const [activeLicenseFile, setActiveLicenseFile] = useState(null);
  const [activeLicenseError, setActiveLicenseError] = useState("");
  const handleActiveLicenseUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, active_license: uploadedFile });
    setActiveLicenseFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //-----------------Letter HOD----------------
  const [hodLetterFile, setHodLetterFile] = useState(null);
  const [hodLetterError, setHodLetterError] = useState("");
  const handleHodLetterUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, letter_hod: uploadedFile });
    setHodLetterFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- MBBS Degree Certificate----------------
  const [mbbsDegreeCertificateFile, setMbbsDegreeCertificateFile] =
    useState(null);
  const [mbbsDegreeCertificateError, setMbbsDegreeCertificateError] =
    useState("");
  const handleMbbsDegreeCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, mbbs_degree_certificate: uploadedFile });
    setMbbsDegreeCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- Clinic Address----------------

  const [clinicStateData, setClinicStateData] = useState([]);

  const [clinicAddress, setClinicAddress] = useState([
    {
      id: "",
      clinic_name: "",
      clinic_address_one: "",
      clinic_address_two: "",
      clinic_country: "",
      clinic_state: "",
      clinic_city: "",
      clinic_pin_code: "",
      clinic_landline: "",
      clinic_stdcode: "",
      clinic_mailing_address: 0,
    },
  ]);

  const addClinicAddressField = () => {
    setClinicAddress([
      ...clinicAddress,
      {
        id: "",
        clinic_name: "",
        clinic_address_one: "",
        clinic_address_two: "",
        clinic_country: "",
        clinic_state: "",
        clinic_city: "",
        clinic_pin_code: "",
        clinic_landline: "",
        clinic_stdcode: "",
        clinic_mailing_address: 0,
      },
    ]);
  };

  // const removeClinicAddressField = (index) => {
  //   setClinicAddress(clinicAddress.filter((_, i) => i !== index));
  // };

  // 22-02 Bharathi
  const removeClinicAddressField = (index, id) => {
    console.log(id);
    if (id !== undefined && id !== null && id !== "") {
      deleteClinicAddress(id);
    }
    setClinicAddress(clinicAddress.filter((_, i) => i !== index));
  };

  const deleteClinicAddress = async (deleteId) => {
    try {
      // console.log(deleteId, "deleteId");
      const response = await axios.post(
        `${baseUrl}/api/delete_clinic`,
        { id: deleteId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Submission failed. Please try again.", "error");
    }
  };
  // ---------

  const handleClinicAddressChange = async (index, field, value) => {
    const updatedClinicAddress = [...clinicAddress];

    if (index >= updatedClinicAddress.length || index < 0) {
      console.error("Invalid index:", index);
      return;
    }

    updatedClinicAddress[index][field] = value;
    setClinicAddress(updatedClinicAddress);

    if (field === "clinic_country") {
      // Fetch states when country is selected
      const states = await fetchStateData(value);
      const updatedStateData = [...clinicStateData]; // clone the existing state data
      updatedStateData[index] = states; // store states per index
      setClinicStateData(updatedStateData);
    }
  };

  const [clinicAddressErrors, setClinicAddressErrors] = useState({});

  const validateClinicAddressFields = () => {
    let isValid = true;
    const newErrors = {};
    clinicAddress.forEach((detail, index) => {
      if (
        detail.clinic_pin_code.trim() &&
        !/^\d{6}$/.test(detail.clinic_pin_code)
      ) {
        isValid = false;
        newErrors[`clinic_pin_code-${index}`] =
          "Clinic pin code must be 6 digits";
      }
      if (detail.clinic_landline.trim() && !detail.clinic_stdcode.trim()) {
        newErrors[`clinic_landline-${index}`] =
          "Clinic STD code cannot be empty";
      } else if (
        !detail.clinic_landline.trim() &&
        detail.clinic_stdcode.trim()
      ) {
        newErrors[`clinic_landline-${index}`] =
          "Clinic landline cannot be empty";
      }
    });
    console.log(newErrors, "newErrors");
    setClinicAddressErrors(newErrors);
    return isValid;
  };

  // -----------------------------------------------------------------

  //----------------- Procedures----------------

  const [procedures, setProcedures] = useState([
    {
      id: "",
      work_procedure: "",
      exp_in_year: "",
      no_of_procedures1: "",
      no_of_procedures2: "",
    },
  ]);

  const [otp, setOtp] = useState({
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
  });
  const addProceduresField = () => {
    setProcedures([
      ...procedures,
      {
        id: "",
        work_procedure: "",
        exp_in_year: "",
        no_of_procedures1: "",
        no_of_procedures2: "",
      },
    ]);
  };

  // const removeProceduresField = (index) => {
  //   setProcedures(procedures.filter((_, i) => i !== index));
  // };

  // -------22-02 Bharathi-------

  const removeProceduresField = (index, id) => {
    if (id !== undefined && id !== null && id !== "") {
      deleteProcedures(id);
    }
    setProcedures(procedures.filter((_, i) => i !== index));
  };

  const deleteProcedures = async (deleteId) => {
    try {
      // console.log(deleteId, "deleteId");
      const response = await axios.post(
        `${baseUrl}/api/delete_work_exp`,
        { id: deleteId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Submission failed. Please try again.", "error");
    }
  };

  // --------------------------------------------

  const handleProceduresChange = (index, field, value) => {
    const updatedClinicAddress = [...procedures];
    updatedClinicAddress[index][field] = value;
    setProcedures(updatedClinicAddress);
  };

  const [proceduresErrors, setProceduresErrors] = useState({});

  // -----------------------------------------------------------------

  const [countryData, setCountryData] = useState([]);
  const fetchCountryData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_country`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setCountryData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [stateData, setStateData] = useState([]);
  const [asiMciStateData, setAsiMciStateData] = useState([]);
  const fetchStateData = async (countryId) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_state`,
        { id: countryId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        return response.data.data;
      } else {
        console.error("Error: Failed to fetch state data");
        return [];
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
      return [];
    }
  };

  useEffect(() => {
    // Function to fetch states based on country
    const fetchStates = async (countryId) => {
      return await fetchStateData(countryId);
    };

    const getStatesForAllClinics = async () => {
      if (formValues.country) {
        const states = await fetchStates(formValues.country);
        setStateData(states);
        setAsiMciStateData(states);
      } else {
        setStateData([]);
      }

      const clinicStatesData = await Promise.all(
        clinicAddress.map(async (address, index) => {
          if (address.clinic_country) {
            return await fetchStates(address.clinic_country);
          }
          return [];
        })
      );
      setClinicStateData(clinicStatesData);
    };

    getStatesForAllClinics();
  }, [formValues.country, clinicAddress]);

  useEffect(() => {
    if (applicationId === 3 && eventType !== "Update") {
      // 20-02 Bharathi change applicationId === 2 to applicationId === 3
      formValues.country = "";
      formValues.nationality = "";
    }
  }, [applicationId, countryData, eventType]);

  // useEffect(() => {
  //   const loadStateData = async () => {
  //     const data = await fetchStateData(101);
  //     setAsiMciStateData(data);
  //   };

  //   loadStateData();
  // }, []);

  useEffect(() => {
    fetchCountryData();
  }, []);

  const tabKeys = [
    "Account Information",
    "Profile Information",
    "Education",
    "Review",
  ];

  // State to track active tab
  const [activeTab, setActiveTab] = useState(tabKeys[0]);

  // Function to move to the next tab
  const handleNextTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };
  const handlePrevTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }
  };
  const [isModal, setModal] = useState("");

  const validateBasicFields = () => {
    const newErrors = {};

    const validateField = (field, message) => {
      if (typeof formValues[field] === "string" && !formValues[field].trim()) {
        newErrors[field] = message;
        console.log(field, typeof formValues[field]);
      }
    };

    const validateRegex = (field, regex, message) => {
      if (formValues[field] && !regex.test(formValues[field])) {
        newErrors[field] = message;
      }
    };

    // First Name validation
    if ([1, 2, 3, 4].includes(applicationId)) {
      validateField("first_name", "First name cannot be empty");
    }

    // Last Name validation
    // if ([1, 2, 3, 4].includes(applicationId)) {
    //  validateField("last_name", "Last name cannot be empty");
    // }

    // Email validation
    validateField("email", "Email cannot be empty");
    if (formValues.email.trim()) {
      validateRegex("email", /^\S+@\S+\.\S+$/, "Invalid email format");
    }

    // Mobile validation
    if ([1, 2, 3, 4].includes(applicationId)) {
      validateField("mobile", "Mobile number cannot be empty");
    }
    // Uncomment the following to validate the mobile format (10 digits)
    // if (formValues.mobile.trim() && applicationId !== 3) {
    if (formValues.mobile.trim() && formValues.mobile_code === "+91") {
      validateRegex(
        "mobile",
        /^\d{10}$/,
        "Invalid mobile number format (must be 10 digits)"
      );
    }

    // Membership Number validation based on applicationId
    if ([5, 6].includes(applicationId)) {
      validateField("membership_no", "Membership Number cannot be empty");
    }

    setErrors(newErrors);

    // ==================== AUTO SCROLL TO FIRST ERROR ====================
    if (Object.keys(newErrors).length > 0) {
      scrollToFirstError(); // ← This will scroll + focus the first error field
      return null;
    }
    // ====================================================================

    // If no errors, return the form data
    if (Object.keys(newErrors).length === 0) {
      const formData = {
        first_name: formValues.first_name,
        last_name: formValues.last_name,
        // middle_name: formValues.middle_name,
        email: formValues.email,
        mobile: formValues.mobile,
        mobile_code: formValues.mobile_code,
      };

      // Conditionally add membership_no if the application_id is 5 or 6
      if ([5, 6].includes(applicationId)) {
        formData.membership_no = formValues.membership_no;
      }

      return formData;
    }

    return null;
  };

  // Timer states
  const [otpExpiryTime, setOtpExpiryTime] = useState(180); // 5 minutes in seconds
  const [resendTime, setResendTime] = useState(60); // 60 seconds cooldown
  const [canResend, setCanResend] = useState(false);

  // Format time as MM:SS
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  // Calculate progress percentage for the timer bar
  const calculateProgress = (current, total) => {
    return (current / total) * 100;
  };

  // Initialize timers on component mount
  // useEffect(() => {
  //   // OTP expiry timer
  //   const expiryInterval = setInterval(() => {
  //     setOtpExpiryTime((prevTime) => {
  //       if (prevTime <= 1) {
  //         clearInterval(expiryInterval)
  //         // showToast("OTP has expired. Please request a new one.", "warning")
  //         return 0
  //       }
  //       return prevTime - 1
  //     })
  //   }, 1000)

  //   // Resend cooldown timer
  //   const resendInterval = setInterval(() => {
  //     setResendTime((prevTime) => {
  //       if (prevTime <= 1) {
  //         clearInterval(resendInterval)
  //         setCanResend(true)
  //         return 0
  //       }
  //       return prevTime - 1
  //     })
  //   }, 1000)

  //   // Cleanup intervals on unmount
  //   return () => {
  //     clearInterval(expiryInterval)
  //     clearInterval(resendInterval)
  //   }
  // }, [])

  // Reset resend timer after requesting new OTP
  const resetResendTimer = () => {
    setResendTime(60);
    setCanResend(false);
  };

  const handleSendOTP = async () => {
    const validatedData = validateBasicFields();
    if (validatedData) {
      setIsLoadingOTP(true); // Start loading
      try {
        const response = await CheckUserDataUserDataApplication(validatedData);
        console.log("OTP sent successfully:", response);

        if (response.status === true && response.application_status === "YES") {
          setIsConfirmModal(true);
          setUserOTPid(response.userid);
        } else if (response.status === true) {
          InsertUserDataOTP(validatedData).then((res) => {
            console.log(res.userid, "userid");
            if (res.status === true) {
              setUserOTPid(res.userid);
              setOtpExpiryTime(180);
              setResendTime(60);
              setModalOpen(true);
            }
          });
          // setModalOpen(true);
        } else {
          if (response.err_type === 1) {
            handleLoginModalOpen();
          } else {
            showToast(response.message, "error");
          }
          // showToast(response.message, "error");
        }
      } catch (error) {
        console.error("Failed to send OTP:", error);
        showToast(error, "error")
      } finally {
        setIsLoadingOTP(false); // Stop loading
      }
    } else {
      console.error("Validation failed. Please check the form fields.");
    }
  };

  const handleResendOTP = () => {
    if (!canResend && resendTime > 0) return;
    const userID = {
      id: userOTPid,
    };
    const formData = new FormData();
    formData.append("id", userID.id);

    ResendUserDataOTP(formData).then((res) => {
      console.log("resend otp", res);
      if (res.status === true) {
        showToast(res.message, "success");
        // Reset OTP expiry timer
        setOtpExpiryTime(180);
        // Reset resend cooldown
        resetResendTimer();
      } else {
        showToast(res.message, "error");
      }
    });
  };

  const hanldeOTPVerify = () => {
    if (otpExpiryTime <= 0) {
      // showToast("OTP has expired. Please request a new one.", "warning")
      return;
    }
    const combinedOtp = otp.digit1 + otp.digit2 + otp.digit3 + otp.digit4;
    console.log(combinedOtp, "combined OTP");

    const formData = new FormData();
    formData.append("id", userOTPid);
    formData.append("otp", combinedOtp);

    VerifyUserDataOTP(formData).then((res) => {
      console.log(res);
      if (res.status === true) {
        showToast(res.message, "success");
        setOtp({
          digit1: "",
          digit2: "",
          digit3: "",
          digit4: "",
        });
        setModalOpen(false);
        if ([5, 6].includes(applicationId)) {
          history.replace(
            `${ROUTE_BASE_URL}/user-member-application-conversion/${encryptSlug(
              `${userOTPid}`
            )}?id=${encryptSlug(`${applicationId}`)}`
          );
          // history.replace(`${ROUTE_BASE_URL}/user-member-application-conversion/${userOTPid}?id=${applicationId}`);
        } else {
          handleNextTab();
          const MemberFormdata = new FormData();
          MemberFormdata.append("id", userOTPid);
          GetMemberInfo(MemberFormdata).then((res) => {
            console.log("member Data", res);
          });
        }
      } else {
        showToast(res.message, "error");
      }
    });
  };

  const isOtpComplete = otp.digit1 && otp.digit2 && otp.digit3 && otp.digit4;
  // const handleOtpChange = (e, digit) => {
  //   setOtp({
  //     ...otp,
  //     [digit]: e.target.value,
  //   });
  // };

  const validatePersonaldetails = () => {
    const newErrors = {};

    const validateField = (field, message) => {
      if (typeof formValues[field] === "string" && !formValues[field].trim()) {
        newErrors[field] = message;
        console.log(field, typeof formValues[field]);
      }
    };

    const validateDropdownField = (field, message) => {
      if (!formValues[field]) newErrors[field] = message;
    };

    const validateRegex = (field, regex, message) => {
      if (!regex.test(formValues[field])) newErrors[field] = message;
    };

    const validateFile = (file, field, message) => {
      if (field === "profile") {
        if (!file && !memberDetails.profile) {
          newErrors[field] = message;
        }

        if (file) {
          const maxSizeInMB = 2;
          const fileSizeInMB = file.size / (1024 * 1024);
          if (fileSizeInMB > maxSizeInMB) {
            newErrors[field] = `File size should not exceed ${maxSizeInMB} MB`;
          }
        }
      }
      if (field === "mci_certificate") {
        if (!file && !memberDetails.mci_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "pg_degree_certificate") {
        if (!file && !memberDetails.pg_degree_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "asi_member_certificate") {
        if (!file && !memberDetails.asi_member_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "active_license") {
        if (!file && !memberDetails.active_license) {
          newErrors[field] = message;
        }
      }
      if (field === "letter_hod") {
        if (!file && !memberDetails.letter_hod) {
          newErrors[field] = message;
        }
      }
      if (field === "mbbs_degree_certificate") {
        if (!file && !memberDetails.mbbs_degree_certificate) {
          newErrors[field] = message;
        }
      }
    };

    // Membership Number validation for specific application IDs

    // Additional fields for non-application ID 5
    if (applicationId !== 5) {
      const fields = [
        "dob",
        "age",
        "nationality",
        "street_line1",
        "street_line2",
        "city",
        "pin",
      ];

      fields.forEach((field) =>
        validateField(
          field,
          `${field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())} cannot be empty`
        )
      );
      validateDropdownField("gender", "Gender cannot be empty");
      // if(applicationId !== 3){
      //   validateDropdownField("zone", "zone cannot be empty");
      // }
      validateDropdownField("country", "Country cannot be empty");
      validateDropdownField("state", "State cannot be empty");

      if (applicationId !== 3 && formValues.pin.trim()) {
        validateRegex("pin", /^\d{6}$/, "Pin code must be 6 digits");
      }
      if (formValues.age) {
        if (isNaN(formValues.age) || formValues.age <= 0) {
          newErrors.age = "Age must be a valid number";
        }
      }
      if (formValues.landline.trim() && !formValues.stdcode.trim()) {
        newErrors.landline = "STD code cannot be empty";
      } else if (!formValues.landline.trim() && formValues.stdcode.trim()) {
        newErrors.landline = "Landline cannot be empty";
      }
    }
    // // Profile file validation for multiple application IDs
    if ([1, 2, 3, 4, 6].includes(applicationId)) {
      validateFile(profileFile, "profile", "Profile cannot be empty");
    }
    // Education fields for specific application IDs

    // ==================== SET ERRORS & AUTO SCROLL ====================
    setErrors(newErrors);
    console.log(newErrors, "errors", profileFile, "profile ");

    if (Object.keys(newErrors).length > 0) {
      scrollToFirstError();        // ← Auto scroll + focus on first error
      return false;
    }
    // =================================================================

    return true;
  };

  const handlePersonalDInsert = () => {
    const isValid = validatePersonaldetails();
    if (!isValid) {
      showToast("Please fill in the required details.", "error");
      console.log("Validation failed");
      return;
    }
    setIsLoadingPersonal(true);
    const clinicAddressIds = clinicAddress
      .map((address) => address.id)
      .filter((id) => id !== "");
    const clinicName = clinicAddress.map((address) => address.clinic_name);
    const clinicAddressOne = clinicAddress.map(
      (address) => address.clinic_address_one
    );
    const clinicAddressTwo = clinicAddress.map(
      (address) => address.clinic_address_two
    );
    const clinicCountry = clinicAddress.map(
      (address) => address.clinic_country
    );
    const clinicState = clinicAddress.map((address) => address.clinic_state);
    const clinicCity = clinicAddress.map((address) => address.clinic_city);
    const clinicPinCode = clinicAddress.map(
      (address) => address.clinic_pin_code
    );
    const clinicStdCode = clinicAddress.map(
      (address) => address.clinic_stdcode
    );
    const clinicLandline = clinicAddress.map(
      (address) => address.clinic_landline
    );
    const clinicMailingAddress = clinicAddress.map(
      (address) => address.clinic_mailing_address
    );
    // Construct the request data object
    const requestData = {
      id: userOTPid || "", // 22-02 Bharathi
      profile: profileFile || "", // 22-02 Bharathi
      application_id: applicationId || "",
      salutation: formValues.salutation || "",
      last_name: formValues.last_name || "",
      middle_name: formValues.middle_name || "",
      father_name: formValues.father_name || "",
      dob: formValues.dob || "",
      // dob: formValues.dob ? new Date(formValues.dob).toISOString().split("T")[0] : "",
      age: formValues.age || "",
      nationality: formValues.nationality || "",
      gender: formValues.gender || "",
      zone: formValues.zone || "",
      street_line1: formValues.street_line1 || "",
      street_line2: formValues.street_line2 || "",
      country: formValues.country || "",
      state: formValues.state || "",
      city: formValues.city || "",
      pin: formValues.pin || "",
      landline: formValues.landline || "",
      stdcode: formValues.stdcode || "",
      mailing_address: formValues.mailing_address || 0,
      //---------------------22-02 Bharathi----------------
      clinic_id: clinicAddressIds.length > 0 ? clinicAddressIds : "",
      clinic_name: clinicName.length > 0 ? clinicName : "",
      clinic_address_one: clinicAddressOne.length > 0 ? clinicAddressOne : "",
      clinic_address_two: clinicAddressTwo.length > 0 ? clinicAddressTwo : "",
      clinic_country: clinicCountry.length > 0 ? clinicCountry : "",
      clinic_state: clinicState.length > 0 ? clinicState : "",
      clinic_city: clinicCity.length > 0 ? clinicCity : "",
      clinic_pin_code: clinicPinCode.length > 0 ? clinicPinCode : "",
      clinic_stdcode: clinicStdCode.length > 0 ? clinicStdCode : "",
      clinic_landline: clinicLandline.length > 0 ? clinicLandline : "",
      clinic_mailing_address:
        clinicMailingAddress.length > 0 ? clinicMailingAddress : "",
      // ------------------------------------------------------------
    };
    // console.log(
    //   "Submitting personal details with",
    //   clinicAddress.length,
    //   "clinic(s)"
    // );
    InsertMembersPersonal(requestData)
      .then((res) => {
        if (res.status === true) {
          showToast(res.message, "success");
          handleNextTab();
        } else {
          showToast(res.message || "Failed to save details", "error");
        }
      })
      .catch((error) => {
        console.error("Error inserting personal data:", error);
        showToast(
          error.message || "Something went wrong. Please try again.",
          "error"
        );
      })
      .finally(() => {
        setIsLoadingPersonal(false);
      });
  };

  // const handlePersonalDInsert = () => {
  //   const isValid = validatePersonaldetails();
  //   if (isValid) {
  //     setIsLoadingPersonal(true);
  //     const clinicAddressIds = clinicAddress
  //       .map((address) => address.id)
  //       .filter((id) => id !== "");
  //     const clinicName = clinicAddress.map((address) => address.clinic_name);
  //     const clinicAddressOne = clinicAddress.map(
  //       (address) => address.clinic_address_one
  //     );
  //     const clinicAddressTwo = clinicAddress.map(
  //       (address) => address.clinic_address_two
  //     );
  //     const clinicCountry = clinicAddress.map(
  //       (address) => address.clinic_country
  //     );
  //     const clinicState = clinicAddress.map((address) => address.clinic_state);
  //     const clinicCity = clinicAddress.map((address) => address.clinic_city);
  //     const clinicPinCode = clinicAddress.map(
  //       (address) => address.clinic_pin_code
  //     );
  //     const clinicStdCode = clinicAddress.map(
  //       (address) => address.clinic_stdcode
  //     );
  //     const clinicLandline = clinicAddress.map(
  //       (address) => address.clinic_landline
  //     );
  //     const clinicMailingAddress = clinicAddress.map(
  //       (address) => address.clinic_mailing_address
  //     );
  //     // Construct the request data object
  //     const requestData = {
  //       id: userOTPid || "", // 22-02 Bharathi
  //       profile: profileFile || "", // 22-02 Bharathi
  //       application_id: applicationId || "",
  //       salutation: formValues.salutation || "",
  //       last_name: formValues.last_name || "",
  //       middle_name: formValues.middle_name || "",
  //       father_name: formValues.father_name || "",
  //       dob: formValues.dob || "",
  //       // dob: formValues.dob ? new Date(formValues.dob).toISOString().split("T")[0] : "",
  //       age: formValues.age || "",
  //       nationality: formValues.nationality || "",
  //       gender: formValues.gender || "",
  //       zone: formValues.zone || "",
  //       street_line1: formValues.street_line1 || "",
  //       street_line2: formValues.street_line2 || "",
  //       country: formValues.country || "",
  //       state: formValues.state || "",
  //       city: formValues.city || "",
  //       pin: formValues.pin || "",
  //       landline: formValues.landline || "",
  //       stdcode: formValues.stdcode || "",
  //       mailing_address: formValues.mailing_address || 0,
  //       //---------------------22-02 Bharathi----------------
  //       clinic_id: clinicAddressIds.length > 0 ? clinicAddressIds : "",
  //       clinic_name: clinicName.length > 0 ? clinicName : "",
  //       clinic_address_one: clinicAddressOne.length > 0 ? clinicAddressOne : "",
  //       clinic_address_two: clinicAddressTwo.length > 0 ? clinicAddressTwo : "",
  //       clinic_country: clinicCountry.length > 0 ? clinicCountry : "",
  //       clinic_state: clinicState.length > 0 ? clinicState : "",
  //       clinic_city: clinicCity.length > 0 ? clinicCity : "",
  //       clinic_pin_code: clinicPinCode.length > 0 ? clinicPinCode : "",
  //       clinic_stdcode: clinicStdCode.length > 0 ? clinicStdCode : "",
  //       clinic_landline: clinicLandline.length > 0 ? clinicLandline : "",
  //       clinic_mailing_address:
  //         clinicMailingAddress.length > 0 ? clinicMailingAddress : "",
  //       // ------------------------------------------------------------
  //     };

  //     console.log(requestData, "requestData");
  //     InsertMembersPersonal(requestData)
  //       .then((res) => {
  //         if (res.status === true) {
  //           showToast(res.message, "success");
  //           handleNextTab(); //22-02 Bharathi
  //         } else {
  //           showToast(res.message, "error");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error inserting personal data:", error);
  //         showToast(error, "error")
  //       })
  //       .finally(() => {
  //         setIsLoadingPersonal(false); // Stop loading
  //       });
  //   } else {
  //     showToast("Please fill in the required details.", "error");
  //     console.log("Validation failed");
  //   }
  // };

  const validateEducationalData = () => {
    const newErrors = {};

    const validateField = (field, message) => {
      if (typeof formValues[field] === "string" && !formValues[field].trim()) {
        newErrors[field] = message;
        console.log(field, typeof formValues[field]);
      }
    };

    const validateDropdownField = (field, message) => {
      if (!formValues[field]) newErrors[field] = message;
    };

    const validateRegex = (field, regex, message) => {
      if (formValues[field] && !regex.test(formValues[field]))
        newErrors[field] = message;
    };

    // const validateFile = (file, field, message) => {
    //   if (!file) newErrors[field] = message;
    // };

    // ---------22-02 Bharathi---------
    const validateFile = (file, field, message) => {
      if (field === "mci_certificate") {
        if (!file && !memberDetails.mci_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "pg_degree_certificate") {
        if (!file && !memberDetails.pg_degree_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "asi_member_certificate") {
        if (!file && !memberDetails.asi_member_certificate) {
          newErrors[field] = message;
        }
      }
      if (field === "active_license") {
        if (!file && !memberDetails.active_license) {
          newErrors[field] = message;
        }
      }
      if (field === "letter_hod") {
        if (!file && !memberDetails.letter_hod) {
          newErrors[field] = message;
        }
      }
      if (field === "mbbs_degree_certificate") {
        if (!file && !memberDetails.mbbs_degree_certificate) {
          newErrors[field] = message;
        }
      }
    };
    // --------------------------------

    // Education fields for specific application IDs
    if (
      [1, 2, 4, 6].includes(applicationId) &&
      `${formValues.country}` === "101"
    ) {
      const eduFields = [
        "edu_undergrad_college",
        "edu_undergrad_university",
        "edu_undergrad_year",
      ];
      eduFields.forEach((field) =>
        validateField(field, `College/University/Year cannot be empty`)
      );
    }

    if (applicationId !== 5) {
      const postgradFields = [
        "edu_postgrad_degree",
        "edu_postgrad_college",
        "edu_postgrad_university",
        "edu_postgrad_year",
      ];
      postgradFields.forEach((field) =>
        validateField(field, `Degree/College/University/Year cannot be empty`)
      );
    }

    // MCI and ASI fields based on application ID
    if ([1, 6].includes(applicationId) && `${formValues.country}` === "101") {
      validateField("mci_council_number", "NMC council Number cannot be empty");
      validateDropdownField("mci_council_state", "NMC state cannot be empty");
      validateField(
        "asi_membership_no",
        "ASI membership number cannot be empty"
      );
      validateDropdownField("asi_state", "ASI state cannot be empty");
    } else if (
      [2, 4].includes(applicationId) &&
      `${formValues.country}` === "101"
    ) {
      validateField("mci_council_number", "NMC council Number cannot be empty");
      validateDropdownField("mci_council_state", "NMC state cannot be empty");
    } else if (applicationId === 3 || formValues.country !== "101") {
      validateField("mci_council_number", "NMC council Number cannot be empty");
    } else if (applicationId === 5 && `${formValues.country}` === "101") {
      validateField(
        "asi_membership_no",
        "ASI membership number cannot be empty"
      );
      validateDropdownField("asi_state", "ASI state cannot be empty");
    }

    // Document validation based on application ID
    if ([1, 6].includes(applicationId) && `${formValues.country}` === "101") {
      validateFile(
        mciCertificateFile,
        "mci_certificate",
        "NMC certificate cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
      validateFile(
        asiMemberCertificateFile,
        "asi_member_certificate",
        "ASI member certificate cannot be empty"
      );
    } else if (applicationId === 2 && `${formValues.country}` === "101") {
      validateFile(
        mciCertificateFile,
        "mci_certificate",
        "NMC certificate cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
    } else if (applicationId === 3 || `${formValues.country}` !== "101") {
      validateFile(
        activeLicenseFile,
        "active_license",
        "Active license cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
    } else if (applicationId === 4 && `${formValues.country}` === "101") {
      validateFile(hodLetterFile, "letter_hod", "HOD letter cannot be empty");
      validateFile(
        mbbsDegreeCertificateFile,
        "mbbs_degree_certificate",
        "MBBS degree certificate cannot be empty"
      );
    } else if (applicationId === 5 && `${formValues.country}` === "101") {
      validateFile(
        asiMemberCertificateFile,
        "asi_member_certificate",
        "ASI member certificate cannot be empty"
      );
    }

    // ==================== SET ERRORS & AUTO SCROLL ====================
    setErrors(newErrors);
    console.log(newErrors, "errors", profileFile, "profile ");

    if (Object.keys(newErrors).length > 0) {
      scrollToFirstError();        // ← Auto scroll + focus on first error
      return false;
    }
    // =================================================================

    return true;
  };

  const handleInsertEduData = () => {
    const isValidate = validateEducationalData();

    if (isValidate) {
      setIsLoadingEducation(true); // Start loading
      const procedureIds = procedures
        .map((data) => data.id)
        .filter((id) => id !== undefined && id !== null && id !== "");

      const workProcedure = procedures.map(
        (procedure) => procedure.work_procedure
      );
      // .filter((procedure) => procedure.trim() !== "");

      const expInYear = procedures.map((procedure) => procedure.exp_in_year);
      // .filter((exp) => exp !== "");

      const noOfProcedures1 = procedures.map(
        (procedure) => procedure.no_of_procedures1
      );
      // .filter((no) => no.trim() !== "");

      const noOfProcedures2 = procedures.map(
        (procedure) => procedure.no_of_procedures2
      );
      // .filter((no) => no.trim() !== "");

      const formData = {
        application_id: applicationId,
        id: userOTPid,

        // Educational fields (undergraduate, postgraduate, superspecialty)
        edu_undergrad_degree: formValues.edu_undergrad_degree,
        other_inter_organisation_value:
          formValues.other_inter_organisation_value,
        edu_undergrad_college: formValues.edu_undergrad_college,
        edu_undergrad_university: formValues.edu_undergrad_university,
        edu_undergrad_year: formValues.edu_undergrad_year,

        edu_postgrad_degree: formValues.edu_postgrad_degree,
        edu_postgrad_college: formValues.edu_postgrad_college,
        edu_postgrad_university: formValues.edu_postgrad_university,
        edu_postgrad_year: formValues.edu_postgrad_year,

        edu_superspecialty_degree: formValues.edu_superspecialty_degree,
        edu_superspecialty_college: formValues.edu_superspecialty_college,
        edu_superspecialty_university: formValues.edu_superspecialty_university,
        edu_superspecialty_year: formValues.edu_superspecialty_year,

        // MCI and ASI fields
        mci_council_number: formValues.mci_council_number,
        mci_council_state: formValues.mci_council_state,
        imr_reg_no: formValues.imr_reg_no,
        asi_membership_no: formValues.asi_membership_no,
        asi_state: formValues.asi_state,

        // -------- 22-02 Bharathi---------
        // Work procedure details
        work_procedure: workProcedure.length > 0 ? workProcedure : "",
        exp_in_year: expInYear.length > 0 ? expInYear : "",
        no_of_procedures1: noOfProcedures1.length > 0 ? noOfProcedures1 : "",
        no_of_procedures2: noOfProcedures2.length > 0 ? noOfProcedures2 : "",
        work_exp_id: procedureIds.length > 0 ? procedureIds : "",
        //----------------------------------------

        // work_exp_id: procedureIds,
        ...{ mci_certificate: mciCertificateFile || "" },
        ...{ pg_degree_certificate: pgDegreeCertificateFile || "" },
        ...{ asi_member_certificate: asiMemberCertificateFile || "" },
        ...{ active_license: activeLicenseFile || "" },
        ...{ letter_hod: hodLetterFile || "" },
        ...{ mbbs_degree_certificate: mbbsDegreeCertificateFile || "" },
        ...{
          other_inter_organisation:
            `${formValues.other_inter_organisation}` || "",
        },
      };

      const cleanedData = Object.fromEntries(
        Object.entries(formData).filter(([key, value]) => value !== null)
      );

      console.log(cleanedData, "cleanedData");
      // InsertMembersEducational(cleanedData)
      //   .then((res) => {
      //     console.log(res);
      //     if (res.status === true) {
      //       showToast(res.message, "success");
      //       const MemberFormdata = new FormData();
      //       MemberFormdata.append("id", userOTPid);
      //       GetMemberInfo(MemberFormdata).then((res) => {
      //         console.log("member Data", res);
      //         handleNextTab();
      //       });
      //     } else {
      //       showToast(res.message, "error");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     showToast(error, "error")
      //   })
      //   .finally(() => {
      //     setIsLoadingEducation(false); // Stop loading
      //   });
        InsertMembersEducational(cleanedData)
        .then((res) => {
          console.log(res);
          if (res.status === true) {
            showToast(res.message, "success");
            const MemberFormdata = new FormData();
            MemberFormdata.append("id", userOTPid);
            GetMemberInfo(MemberFormdata).then((res) => {
              console.log("member Data", res);
              handleNextTab();
            });
          } else {
            showToast(res.message || "Failed to save details", "error");
          }
        })
        .catch((error) => {
          console.error("Error inserting personal data:", error);
          showToast(error.message || "Something went wrong. Please try again.", "error");
        })
        .finally(() => {
          setIsLoadingPersonal(false);
        });
    } else {
      showToast("Please fill in the required details.", "error");
    }
  };

  const handleCreateFresh = () => {
    const formData = new FormData();
    formData.append("id", userOTPid);
    DeleteOldMemberApplication(formData).then((res) => {
      if (res.status === true) {
        showToast(res.message, "success");
        setIsConfirmModal(false);
        const validatedData = validateBasicFields();
        InsertUserDataOTP(validatedData).then((res) => {
          if (res.status === true) {
            setUserOTPid(res.userid);
            setModalOpen(true);
            setOtpExpiryTime(180);
            setResendTime(60);
          }
        });
      }
    });
  };

  const handleContinueWithOld = () => {
    setIsConfirmModal(false);
    const formData = new FormData();
    formData.append("id", userOTPid);

    const MemberFormdata = formData;

    GetMemberInfo(MemberFormdata)
      .then((res) => {
        if (res.status === true && res.data && res.data.length > 0) {
          seteventType("Update");
          const details = res.data[0];
          setData(res.data[0]);
          // const newApplicationId = details.application_id;
          // setApplicationID(newApplicationId)
          setMemberDetails(details);
          console.log(eventType, "eventype");
          let countryValue = "";
          let nationalityValue = "";

          if (applicationId === 3) {
            countryValue = details.country || "";
          } else {
            countryValue = 101;
            nationalityValue = details.nationality || "Indian";
          }
          setFormValues({
            application_no: details.application_no || "",
            membership_no: details.membership_no || "",
            salutation: details.salutation || "",
            first_name: details.first_name || "",
            last_name: details.last_name || "",
            middle_name: details.middle_name || "",
            email: details.email || "",
            mobile: details.mobile || "",
            mobile_code: details.mobile_code || "",
            father_name: details.father_name || "",
            dob: details.dob || "",
            age: String(details.age) || "",
            nationality: nationalityValue,
            gender: details.gender || "",
            zone: details.zone,
            street_line1: details.street_line1 || "",
            street_line2: details.street_line2 || "",
            country: countryValue,
            state: details.state || "",
            profile: details.profile || "",
            city: details.city || "",
            pin: details.pin || "",
            landline: details.landline || "",
            stdcode: details.stdcode || "",
            mailing_address: details.mailing_address || "",
            edu_undergrad_degree: details.edu_undergrad_degree || "",
            edu_undergrad_college: details.edu_undergrad_college || "",
            edu_undergrad_university: details.edu_undergrad_university || "",
            edu_undergrad_year: String(details.edu_undergrad_year) || "",
            edu_postgrad_degree: details.edu_postgrad_degree || "",
            edu_postgrad_college: details.edu_postgrad_college || "",
            edu_postgrad_university: details.edu_postgrad_university || "",
            edu_postgrad_year: String(details.edu_postgrad_year) || "",
            edu_superspecialty_degree: details.edu_superspecialty_degree || "",
            edu_superspecialty_college:
              details.edu_superspecialty_college || "",
            edu_superspecialty_university:
              details.edu_superspecialty_university || "",
            edu_superspecialty_year:
              String(details.edu_superspecialty_year) || "",
            mci_council_number: details.mci_council_number || "",
            mci_council_state: details.mci_council_state || "",
            imr_reg_no: details.imr_reg_no || "",
            asi_membership_no: details.asi_membership_no || "",
            asi_state: details.asi_state || "",
            other_inter_organisation: details.other_inter_organisation
              ? details.other_inter_organisation.split(",").filter(Boolean)
              : [],
            other_inter_organisation_value:
              details.other_inter_organisation_value || "",
          });

          // Handle clinic data if it exists
          if (res.clinic && res.clinic.length > 0) {
            const clinicData = res.clinic.map((item) => ({
              id: item.id || "",
              clinic_name: item.clinic_name || "",
              clinic_address_one: item.clinic_address_one || "",
              clinic_address_two: item.clinic_address_two || "",
              //----------------  22-02 Bharathi--------------
              // clinic_country: item.clinic_country_name || "", // Displaying country name
              // clinic_state: item.clinic_state_name || "", // Displaying state name
              clinic_country: item.clinic_country || "",
              clinic_state: item.clinic_state || "",
              // -----------------------------------
              clinic_city: item.clinic_city || "",
              clinic_pin_code: item.clinic_pin_code || "",
              clinic_landline: item.clinic_landline || "",
              clinic_stdcode: item.clinic_stdcode || "",
              clinic_mailing_address: item.clinic_mailing_address || 0, //22-02 Bharathi
            }));
            handleClinicData(clinicData);
            setClinicAddress(clinicData);
          }

          // Handle work experience data if it exists
          if (res.work_exp && res.work_exp.length > 0) {
            const proceduresData = res.work_exp.map((item) => ({
              id: item.id || "",
              work_procedure: item.work_procedure || "",
              exp_in_year: String(item.exp_in_year) || "",
              no_of_procedures1: item.no_of_procedures1 || "",
              no_of_procedures2: item.no_of_procedures2 || "",
            }));
            setProcedures(proceduresData);
          }
          // if (parseInt(decryptedId) !== newApplicationId) {
          //   history.replace(`/admin/user-member-application/${newApplicationId}`);
          // }
          handleNextTab();
        } else {
          showToast("No member data found", "error");
        }
      })
      .catch((error) => {
        // If an error occurs during the request, handle it here
        showToast(error.message || "An error occurred", "error");
      });
  };
  useEffect(() => {
    if (!window.Razorpay) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const createOrder = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/create_order`,
        { member_id: userOTPid },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      // if (response.data.status) {
      return response.data;
      // } else {
      //   console.error("Error: Failed to fetch user data");
      //   return null;
      // }
    } catch (error) {
      console.error("Error fetching users data:", error);
      return null;
    }
    // try {
    //   const response = await fetch(`${baseUrl}/api/create_order`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Basic ${btoa("rzp_test_0VhW5kvbe3uCFF:xKgvmsOP0R7L4AyaUiFjGbRO")}`,
    //     },
    //     body:JSON.stringify({
    //       member_id:19
    //     }),
    //   });

    //   const data = await response.json();
    //   return data.id; // Order ID
    // } catch (error) {
    //   console.error("Error creating order:", error);
    //   return null;
    // }
  };
  const capturePayment = async (paymentId, amount) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/verify_and_capture`,
        {
          razorpay_payment_id: paymentId,
          amount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      // if (response.data.status) {
      return response.data;
      // } else {
      //   console.error("Error: Failed to fetch user data");
      //   return null;
      // }
    } catch (error) {
      console.error("Error fetching users data:", error);
      return null;
    }
  };
  // Handle payment
  const handlePayment = async () => {
    try {
      if (applicationId !== 5 && applicationId !== 6) {
        const orderData = await createOrder();
        if (!orderData.id) {
          return;
        }
        const options = {
          key: razorpayKey,
          amount: orderData.amount,
          currency: orderData.currency,
          order_id: orderData.id,
          description: "AMASI Member Application Payment",
          prefill: { 
            name: formValues.salutation || formValues.first_name || formValues.middle_name || formValues.last_name
            ? `${formValues.salutation || ''} ${formValues.first_name || ''} ${formValues.middle_name || ''} ${formValues.last_name || ''}`
                .trim()
                .replace(/\s+/g, ' ')
            : 'N/A', 
            email: formValues.email, 
            contact: formValues.mobile 
          },
          notes: { 
            "Application Name": memberApplicationName, 
            "Name": formValues.salutation || formValues.first_name || formValues.middle_name || formValues.last_name
              ? `${formValues.salutation || ''} ${formValues.first_name || ''} ${formValues.middle_name || ''} ${formValues.last_name || ''}`
                  .trim()
                  .replace(/\s+/g, ' ')
              : 'N/A',
            "Email": formValues.email || 'N/A', 
            "Contact": formValues.mobile || 'N/A' 
          },
          // theme: { color: "#F37254" },
          handler: async function (response) {
            console.log(
              `Payment Successful! Payment ID: ${response.razorpay_payment_id}`,
              response
            );
            // const requestData = new FormData();
            // requestData.append("id", userOTPid);
            // requestData.append("amount", orderData.amount);
            // requestData.append("currency", orderData.currency);
            // requestData.append("payment_status", "Success");
            // requestData.append("payment_id", response.razorpay_payment_id);
            // requestData.append("payment_json",JSON.stringify(response));
            try{
            const hasCapturedPayment = await capturePayment(
              orderData.id,
              orderData.amount
            );
            if (hasCapturedPayment) {
              console.log(
                "Payment already completed for this order.",
                hasCapturedPayment
              );
              // showToast("Payment already completed for this order.", "info");
            }
            const requestData = {
              id: userOTPid,
              amount: orderData.amount,
              currency: orderData.currency,
              payment_status: "Success",
              payment_id: `${response.razorpay_payment_id}`,
              payment_json: JSON.stringify(response),
              application_id: applicationId,
            };
            console.log(`Payment Successful! Request Data:`, requestData);
            InsertMembersPaymentDetails(requestData).then((res) => {
              if (res.status === true) {
                showToast(res.message, "success");
                history.push(
                  `${ROUTE_BASE_URL}/user-member-application-payment/${encryptSlug(
                    `${res.application_no}`
                  )}?id=${encryptSlug(`${applicationId}`)}`
                );
              } else {
                showToast(res.message, "error");
              }
            }).catch((error) => {
              console.error("Error Payment Successful! Request:", error);
              showToast(error.message || "Something went wrong. Please try again.", "error");
            });
          } catch (err) {           
            console.error("Payment Successful! Request Error: ", err);  
            let message = "A network error occurred. Please try again later.";  
            if (err.response) {
              message =
                err.response.data?.message ||
                err.response.data?.error ||
                `Server error (${err.response.status})`;
            } else if (err.request) {
              message = "No response from server. Please check your internet connection.";
            } else {
              message = err.message || "Request failed";
            }  
            showToast(message, "error")
          }
          },

          modal: {
            ondismiss: function () {
              console.log("Payment popup closed");
              // const requestData = new FormData();
              // requestData.append("id", userOTPid);
              // requestData.append("amount", orderData.amount);
              // requestData.append("currency", orderData.currency);
              // requestData.append("payment_status", "Failed");
              // requestData.append("payment_id", "");
              // requestData.append("payment_json","");
              try{
              const requestData = {
                id: userOTPid,
                amount: orderData.amount,
                currency: orderData.currency,
                payment_status: "Failed",
                payment_id: "",
                payment_json: "",
                application_id: applicationId,
              };
              console.log(`Payment Successful! Failed Data:`, requestData);
              InsertMembersPaymentDetails(requestData).then((res) => {
                if (res.status === true) {
                  showToast(res.message, "success");
                  history.push(
                    `${ROUTE_BASE_URL}/user-member-application-payment-failed/${encryptSlug(
                      `${res.application_no}`
                    )}`
                  );
                } else {
                  showToast(res.message, "error");
                }
              }).catch((error) => {
                console.error("Error Payment Successful! Request:", error);
                showToast(error.message || "Something went wrong. Please try again.", "error");
              });
            } catch (err) {
              console.error("Error during submission:", err)             
              console.error("Payment Error: ", err);  
              let message = "A network error occurred. Please try again later.";  
              if (err.response) {
                message =
                  err.response.data?.message ||
                  err.response.data?.error ||
                  `Server error (${err.response.status})`;
              } else if (err.request) {
                message = "No response from server. Please check your internet connection.";
              } else {
                message = err.message || "Request failed";
              }  
              showToast(message, "error")
            }
            },
          },
          retry: {
            enabled: false,
            max_count: 1,
          },
        };

        if (!window.Razorpay) {
          console.log("Razorpay SDK failed to load. Are you online?");
          return;
        }
        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();
      }
      // else{
      //   history.push(`${ROUTE_BASE_URL}/user-member-application-payment/${applicationId}`);
      // }
    } 
    // catch (error) {
    //   console.error("Payment Error :", error);
    //   let message = "A network error occurred, or the server is temporarily busy. Please try again later.";
    //   if (error.response?.data?.message) {
    //     message = error.response.data.message;
    //   }
    //   showToast(message, "error")
    // }
    catch (err) {
      console.error("Payment Error: ", err);  
      let message = "A network error occurred. Please try again later.";  
      if (err.response) {
        message =
          err.response.data?.message ||
          err.response.data?.error ||
          `Server error (${err.response.status})`;
      } else if (err.request) {
        message = "No response from server. Please check your internet connection.";
      } else {
        message = err.message || "Request failed";
      }  
      showToast(message, "error")
    }
  };

  // 20-02 Bharathi

  const handleOtpChange = (e, digit) => {
    const { value } = e.target;
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      setOtp({
        ...otp,
        [digit]: value,
      });
      const nextDigit = `digit${parseInt(digit.charAt(5)) + 1}`;
      if (value && digit !== "digit4") {
        document.getElementById(nextDigit).focus();
      }
    }
  };
  const handleClinicData = (clinicData) => {
    clinicData.forEach((item, index) => {
      handleClinicAddressChange(index, "clinic_country", item.clinic_country);
      handleClinicAddressChange(index, "clinic_state", item.clinic_state);
      // Add other fields if needed
    });
  };
  // useEffect(() => {
  //   const loadStateData = async () => {
  //     const data = await fetchStateData(101);
  //     setAsiMciStateData(data);
  //   };
  //   loadStateData();
  // }, []);

  // 24-02 Bharathi
  const [memberApplicationName, setMemberApplicationName] = useState("");
  useEffect(() => {
    GetUserMemberApplicationData()
      .then((res) => {
        console.log(res, "UserMemberData");
        const applicationData = res.data.find(
          (item) => `${item.id}` === decryptedId
        );
        setMemberApplicationName(applicationData.application_name);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleStateChange = (value) => {
    const selectedStateId = Number(value);
    console.log(selectedStateId, "Selected State ID");

    setFormValues((prevState) => ({
      ...prevState,
      state: value,
    }));

    console.log(stateData, "stateData Array");

    const selectedState = stateData.find(
      (state) => state.id === selectedStateId
    );
    console.log(selectedState, "Selected State");

    if (selectedState) {
      console.log(selectedState.name, "State Name from stateData");

      const foundZone = AllzoneData.find((zone) => {
        return (
          Array.isArray(zone.states) && zone.states.includes(selectedState.name)
        );
      });

      console.log(foundZone, "Found Zone");

      if (foundZone) {
        setFormValues((prevState) => ({
          ...prevState,
          zone: foundZone.value,
        }));
      } else {
        setFormValues((prevState) => ({
          ...prevState,
          zone: "",
        }));
      }
    } else {
      console.log("State not found in stateData array");
      setFormValues((prevState) => ({
        ...prevState,
        zone: "",
      }));
    }
  };

  const handleCountryChange = (value) => {
    const selectedCountryId = Number(value);
    console.log(selectedCountryId, "Selected Country ID");
    setFormValues((prevState) => ({
      ...prevState,
      country: value,
    }));
    console.log(countryData, "countryData Array");

    const selectedCountry = countryData.find(
      (country) => country.id === selectedCountryId
    );
    console.log(selectedCountry, "Selected Courntry");

    if (selectedCountry) {
      console.log(selectedCountry.nationality, "Country Name from countryData");
      setFormValues((prevState) => ({
        ...prevState,
        nationality: selectedCountry.nationality,
      }));
    } else {
      if (selectedCountryId !== 101) {
        setFormValues((prevState) => ({
          ...prevState,
          nationality: "",
        }));
      }
    }
  };

  const workExpInYears = (from, to) => {
    const year1 = new Date(from).getFullYear();
    const year2 = new Date(to).getFullYear();
    return year2 - year1;
  };

  const [loginModal, setLoginModal] = useState(false);

  const handleLoginModalOpen = () => {
    setLoginModal(true);
  };

  const handleLoginModalClose = () => {
    setLoginPasswordError();
    setLoginModal(false);
  };
  const [loginPassword, setLoginPassword] = useState("");
  const [loginPasswordError, setLoginPasswordError] = useState("");

  const handleLogin = async () => {
    if (loginPassword.trim() === "") {
      setLoginPasswordError("Password cannot be empty");
      return;
    } else {
      try {
        const response = await axios.post(
          `${baseUrl}/api/memberlogin`,
          {
            username: formValues.email,
            password: loginPassword,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );

        if (response.data.status) {
          showToast(response.data.message, "success");
          const user = response.data.data[0];
          // Store user details
          Cookies.set("memberUserId", response.data.data[0].id, { expires: 1 });
          localStorage.setItem("loginMemberUserId", response.data.data[0].id);
          const fullName = `${user.first_name}${
            user.middle_name ? " " + user.middle_name : ""
          }${user.last_name ? " " + user.last_name : ""}`;
          localStorage.setItem("loginMemberUserName", fullName);
          // localStorage.setItem("loginMemberUserName", response.data.data[0].full_name);
          localStorage.setItem(
            "loginMemberUserImage",
            response.data.data[0].profile
          );
          history.replace(
            `${ROUTE_BASE_URL}/user-member-application-preview/${encryptSlug(
              `${response.data.data[0].id}`
            )}`
          );
          // history.replace(`${ROUTE_BASE_URL}/user-member-application-preview/${response.data.data[0].id}`);
        } else {
          showToast(response.data.message, "error");
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Please try again", "error");
      }
    }
  };

  return (
    <div div className="check_box_clr_change">
      <ToastMessage />
      <section className="user_div_total">
        <Header />
        <div className="container ">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="pt-4 pb-2">
                  <h2 className="heading_page">
                    Online Membership Application System (OMAS)-
                    {memberApplicationName}
                  </h2>
                </div>
                <div className="body wizard_validation user_tab user_application_div_clr">
                  <form id="wizard_with_validation" method="">
                    {/* <Tabs
                      activeKey={activeTab}
                      onSelect={() => false}
                      // onSelect={(k) => setActiveTab(k)}
                      defaultActiveKey={"Account Information"}
                      id="Account Information"
                    > */}
                      <Tabs
                        activeKey={activeTab}
                        onSelect={() => false}
                        defaultActiveKey={"Account Information"}
                        id="Account Information"
                        className="stepper-tabs"
                        style={{ borderColor : "transparent" }}
                      >
  
                      <Tab
                        eventKey="Account Information"
                        // title="Validation"
                        // tabClassName="form_wizard_tab"
                        title={<span className="step-label"><span className="step-number">1</span><span className="step-text">Validation</span></span>}
                        tabClassName="stepper-tab"
                      >
                        <div className="row clearfix">
                          {[5, 6].includes(applicationId) && (
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  Membership Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  className={`form-control ${
                                    errors.membership_no ? "red_border" : ""
                                  }`}
                                  value={formValues.membership_no}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "membership_no",
                                      e.target.value
                                    )
                                  }
                                />
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.membership_no}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          {[1, 2, 3, 4].includes(applicationId) && (
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  First Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.first_name ? "red_border" : ""
                                  }`}
                                  value={formValues.first_name}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/[^A-Za-z]/g, "");
                                    // if (/^dr/i.test(input)) {
                                    //   input = input.replace(/^dr/i, "");
                                    // }
                                    handleInputChange("first_name", input);
                                  }}
                                />
                                <small>
                                  (Only alphabetic characters are allowed.)
                                </small>
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.first_name}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          {[1, 2, 3, 4].includes(applicationId) && (
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  Last Name
                                  {/* <span className="text-danger">*</span> */}
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.last_name ? "red_border" : ""
                                  }`}
                                  value={formValues.last_name}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/[^A-Za-z]/g, "");
                                    handleInputChange("last_name", input);
                                  }}
                                />
                                <small>
                                  (Only alphabetic characters are allowed.)
                                </small>
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.last_name}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-md-6">
                            <div className="form-group pos_relative">
                              <label>
                                Email Id <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                className={`form-control ${
                                  errors.email ? "red_border" : ""
                                }`}
                                value={formValues.email}
                                onChange={(e) =>
                                  handleInputChange("email", e.target.value)
                                }
                              />
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.email}
                                </p>
                              )}
                            </div>
                          </div>
                          {[1, 2, 3, 4].includes(applicationId) && (
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  Mobile Number
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                  <ReactPhoneInput
                                    defaultCountry={applicationId !== 3 && "IN"}
                                    value={phoneNumber}
                                    onChange={handleMobileChange}
                                    international
                                    withCountryCallingCode
                                    className={`custom-phone-input form-control ${
                                      errors.mobile ? "red_border" : ""
                                    }`}
                                    placeholder="Enter your mobile number"
                                  />
                                </div>
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.mobile}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-md-12">
                            <div>
                              <div>
                                {/* for otp design  */}
                                {/* <button onClick={() => setModal('Large Modal1')} className="btn btn-outline-success btn-block saveand_proced_button" type="button">OTP</button> */}
                              </div>
                              <div>
                                {/* for already registered design */}
                                {/* <button onClick={() => setModal('Large Modal')} className="btn btn-outline-success btn-block saveand_proced_button" type="button"> Aleready Registerd</button> */}
                              </div>
                              <div>
                                {/* <button
                                  // onClick={handleNextTab}
                                  onClick={handleSendOTP}
                                  className="btn btn-outline-success btn-block saveand_proced_button"
                                  type="button"
                                >
                                  Save & Proceed
                                </button> */}
                                <button
                                  onClick={handleSendOTP}
                                  className="btn btn-outline-success btn-block saveand_proced_button"
                                  type="button"
                                  disabled={isLoadingOTP}
                                >
                                  {isLoadingOTP ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="ms-2">
                                        Processing...
                                      </span>
                                    </>
                                  ) : (
                                    "Save & Proceed"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab
                        eventKey="Profile Information"
                        // title="Personal Details"
                        // tabClassName="form_wizard_tab"
                        title={<span className="step-label"><span className="step-number">2</span><span className="step-text">Personal Details</span></span>}
                        tabClassName="stepper-tab"
                      >
                        <fieldset>
                          <div className="row clearfix">
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <div className="col-lg-12 col-md-12 pos_relative">
                                <label>
                                  Upload Image{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <p style={{ margin: "0" }} />
                                <div className="pos_re">
                                  <img
                                    src={
                                      (!profileFile &&
                                        !memberDetails.profile) ||
                                      profileFile
                                        ? image
                                        : `${memberDetails.profile}`
                                    }
                                    width="80"
                                    height="80"
                                    className="img-thumbnail rounded-circle width_profile_image"
                                    alt="person"
                                    onClick={handleImageClick}
                                    style={{ cursor: "pointer" }}
                                  />
                                  <i
                                    onClick={handleImageClick}
                                    className="fa fa-pencil upload_image_edit_icon"
                                  />
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    accept=".png,.jpg,.jpeg,.webp,.svg"
                                    onChange={handleFileChange}
                                  />
                                </div>
                                <small>
                                  (Maximum file size allowed: 2MB ){" "}
                                </small>
                                {errors && (
                                  // <p className="pos_abos left_15">
                                  <input
                                    disabled
                                    name="profile"
                                    type="text"
                                    className={`form-group pos_abos left_15 ${
                                      errors.profile ? " red_border text-danger" : ""
                                    }`}
                                    value={errors.profile}
                                    hidden={errors.profile ? false: true}
                                  />
                                  // </p>
                                )}
                              </div>
                            )}
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>Name Salutation </label>
                                <select
                                  className={`multiselect multiselect-custom form-control cursor-pointer`}
                                  value={formValues.salutation}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "salutation",
                                      e.target.value
                                    )
                                  }
                                  displayEmpty
                                >
                                  <option
                                    style={{ cursor: "pointer" }}
                                    value=""
                                  >
                                    --Select a Name Salutation--
                                  </option>
                                  {salutationData.map((data) => (
                                    <option
                                      style={{ cursor: "pointer" }}
                                      key={data.id}
                                      value={data.value}
                                    >
                                      {data.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  First Name{" "}
                                  {/* <span className="text-danger">*</span> */}
                                </label>
                                <input
                                  disabled
                                  type="text"
                                  className={`form-control ${
                                    errors.first_name ? "red_border" : ""
                                  }`}
                                  value={formValues.first_name}
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const nameRegex = /^[A-Za-z\s]+$/;
                                    if (input === "" || nameRegex.test(input)) {
                                      handleInputChange("first_name", input);
                                    }
                                  }}
                                />
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.first_name}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  Middle Name{" "}
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  value={formValues.middle_name}
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const nameRegex = /^[A-Za-z\s]+$/;
                                    if (input === "" || nameRegex.test(input)) {
                                      handleInputChange("middle_name", input);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group pos_relative">
                                <label>
                                  Last Name{" "}
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  value={formValues.last_name}
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const nameRegex = /^[A-Za-z\s]+$/;
                                    if (input === "" || nameRegex.test(input)) {
                                      handleInputChange("last_name", input);
                                    }
                                  }}
                                />
                              </div>
                            </div>

                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Father's Name{" "}
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control`}
                                      value={formValues.father_name}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "father_name",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative date_picker_div">
                                    <label>
                                      Date of Birth{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Datepicker
                                      selectedDate={
                                        formValues.dob
                                          ? new Date(formValues.dob)
                                          : null
                                      }
                                      onDateChange={(date) => {
                                        const newDob = date
                                          ? dayjs(date).format(dateFormatList)
                                          : "";
                                        const newAge = calculateAge(newDob);
                                        setFormValues((prev) => ({
                                          ...prev,
                                          dob: newDob,
                                          age: newAge,
                                        }));
                                      }}
                                      className={`form-control ${
                                        errors.dob ? "red_border" : ""
                                      }`}
                                      placeholder="DD/MM/YYYY"
                                    />
                                    {errors?.dob && (
                                      <p className="text-danger pos_abos">
                                        {errors.dob}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Age
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control ${
                                        errors.age ? "red_border" : ""
                                      }`}
                                      value={formValues.age}
                                      disabled
                                    />
                                    {errors?.age && (
                                      <p className="text-danger pos_abos">
                                        {errors.age}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Nationality{" "}
                                    </label>
                                    <input
                                      type="text"
                                      value={formValues.nationality}
                                      className="form-control"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Gender{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className={`multiselect multiselect-custom form-control cursor-pointer ${
                                        errors.gender ? "red_border" : ""
                                      }`}
                                      value={formValues.gender}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "gender",
                                          e.target.value
                                        )
                                      }
                                      displayEmpty
                                    >
                                      <option
                                        style={{ cursor: "pointer" }}
                                        value=""
                                      >
                                        -- Select Gender Type--
                                      </option>
                                      {genderData.map((data) => (
                                        <option
                                          style={{ cursor: "pointer" }}
                                          key={data.id}
                                          value={data.value}
                                        >
                                          {data.value}
                                        </option>
                                      ))}
                                    </select>
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.gender}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="header">
                                    <h2>Permanent Address</h2>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Street line 1{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        errors.street_line1 ? "red_border" : ""
                                      }`}
                                      value={formValues.street_line1}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "street_line1",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.street_line1}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Street line 2{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        errors.street_line2 ? "red_border" : ""
                                      }`}
                                      value={formValues.street_line2}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "street_line2",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.street_line2}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Country{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={countryData}
                                        dropdownValue={formValues.country}
                                        setDropdownValue={handleCountryChange}
                                        // setDropdownValue={(value) =>
                                        //   handleInputChange("country", value)
                                        // }
                                        // disabled={applicationId !== 3}
                                        applicationId={applicationId}
                                        name="country name"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        data={data}
                                        fieldName="country"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"country"}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <label>
                                      State{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={stateData}
                                        dropdownValue={formValues.state}
                                        setDropdownValue={handleStateChange}
                                        name="State"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        fieldName="state"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"state"}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {applicationId !== 3 &&
                                  formValues.country === "101" && (
                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Your Zone</label>
                                        <input
                                          type="text"
                                          value={formValues.zone}
                                          className="form-control"
                                          disabled={
                                            applicationId === 3 ||
                                            !formValues.state ||
                                            formValues.state.length === 0
                                          }
                                          // readOnly
                                        />
                                      </div>
                                    </div>
                                  )}
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      City / District{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        errors.city ? "red_border" : ""
                                      }`}
                                      value={formValues.city}
                                      onChange={(e) => {
                                        let input = e.target.value;
                                        input = input.replace(
                                          /[^A-Za-z ]/g,
                                          ""
                                        );
                                        handleInputChange("city", input);
                                      }}
                                    />
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.city}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Postal / Zip Code{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control ${
                                        errors.pin ? "red_border" : ""
                                      }`}
                                      value={formValues.pin}
                                      onChange={(e) =>
                                        handleInputChange("pin", e.target.value)
                                      }
                                    />
                                    <small>
                                     (Please enter numbers only.)
                                   </small>
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.pin}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>Landline</label>
                                    <div className="landline_d_flex">
                                      <input
                                        type="number"
                                        style={{ width: "30%" }}
                                        className="form-control"
                                        value={formValues.stdcode}
                                        placeholder="STD"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "stdcode",
                                            e.target.value
                                          )
                                        }
                                      />

                                      <input
                                        type="number"
                                        className={`form-control ${
                                          errors.landline ? "red_border" : ""
                                        }`}
                                        value={formValues.landline}
                                        onChange={(e) =>
                                          handleInputChange(
                                            "landline",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {errors && (
                                        <p className="text-danger pos_abos">
                                          {errors.landline}
                                        </p>
                                      )}
                                    </div>
                                    <small>
                                      (Please enter numbers only.)
                                      </small>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="text-right">
                                    <label>
                                      <FormCheck
                                        type="checkbox"
                                        id={`checkbox-permanent`}
                                        label="Use this as mailing address"
                                        checked={
                                          formValues.mailing_address === 1
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            handleInputChange(
                                              "mailing_address",
                                              1
                                            );

                                            const updatedClinicAddress =
                                              clinicAddress.map((address) => ({
                                                ...address,
                                                clinic_mailing_address: 0,
                                              }));
                                            setClinicAddress(
                                              updatedClinicAddress
                                            );
                                          } else {
                                            handleInputChange(
                                              "mailing_address",
                                              0
                                            );
                                          }
                                        }}
                                      />
                                    </label>
                                  </div>
                                </div>
                                {clinicAddress.map((data, index) => (
                                  <>
                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Clinic Name</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data.clinic_name}
                                          onChange={(e) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_name",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Street line 1</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data.clinic_address_one}
                                          onChange={(e) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_address_one",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Street line 2</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data.clinic_address_two}
                                          onChange={(e) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_address_two",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Country</label>
                                        <CustomDropdown
                                          dropdownData={countryData}
                                          dropdownValue={
                                            clinicAddress[index].clinic_country
                                          }
                                          setDropdownValue={(value) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_country",
                                              value
                                            )
                                          }
                                          DataRefechRetrigger={
                                            DataRefechRetrigger
                                          }
                                          name="country"
                                          fieldName="clinic_country"
                                          errors={errors}
                                          formValues={formValues}
                                          eventType={
                                            eventType === "Update"
                                              ? "Update"
                                              : "Add"
                                          }
                                          FeildName={"clinic_country"}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>State</label>
                                        <CustomDropdown
                                          dropdownData={
                                            clinicStateData[index] || []
                                          }
                                          dropdownValue={data.clinic_state}
                                          setDropdownValue={(value) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_state",
                                              value
                                            )
                                          }
                                          ShouldValidate={false}
                                          name="state"
                                          fieldName="clinic_state"
                                          errors={errors}
                                          formValues={formValues}
                                          disabled={!data.clinic_country}
                                          eventType={
                                            eventType === "Update"
                                              ? "Update"
                                              : "Add"
                                          }
                                          FeildName={"clinic_state"}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>City / District</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            clinicAddressErrors[
                                              `clinic_city-${index}`
                                            ]
                                              ? "red_border"
                                              : ""
                                          }`}
                                          value={data.clinic_city}
                                          onChange={(e) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_city",
                                              e.target.value
                                            )
                                          }
                                        />
                                        {clinicAddressErrors[
                                          `clinic_city-${index}`
                                        ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              clinicAddressErrors[
                                                `clinic_city-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Postal / Zip Code</label>
                                        <input
                                          type="number"
                                          className={`form-control ${
                                            clinicAddressErrors[
                                              `clinic_pin_code-${index}`
                                            ]
                                              ? "red_border"
                                              : ""
                                          }`}
                                          value={data.clinic_pin_code}
                                          onChange={(e) =>
                                            handleClinicAddressChange(
                                              index,
                                              "clinic_pin_code",
                                              e.target.value
                                            )
                                          }
                                        />
                                        <small>
                                          (Please enter numbers only.)
                                        </small>
                                        {clinicAddressErrors[
                                          `clinic_pin_code-${index}`
                                        ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              clinicAddressErrors[
                                                `clinic_pin_code-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                      <div className="form-group pos_relative">
                                        <label>Landline</label>
                                        <div className="landline_d_flex">
                                          <input
                                            type="number"
                                            style={{ width: "30%" }}
                                            className="form-control"
                                            value={data.clinic_stdcode}
                                            placeholder="STD"
                                            onChange={(e) =>
                                              handleClinicAddressChange(
                                                index,
                                                "clinic_stdcode",
                                                e.target.value
                                              )
                                            }
                                          />

                                          <input
                                            type="number"
                                            className={`form-control ${
                                              clinicAddressErrors[
                                                `clinic_landline-${index}`
                                              ]
                                                ? "red_border"
                                                : ""
                                            }`}
                                            value={data.clinic_landline}
                                            onChange={(e) =>
                                              handleClinicAddressChange(
                                                index,
                                                "clinic_landline",
                                                e.target.value
                                              )
                                            }
                                          />
                                          {clinicAddressErrors[
                                            `clinic_landline-${index}`
                                          ] && (
                                            <p className="text-danger pos_abos">
                                              {
                                                clinicAddressErrors[
                                                  `clinic_landline-${index}`
                                                ]
                                              }
                                            </p>
                                          )}
                                        </div>
                                        <small>
                                      (Please enter numbers only.)
                                      </small>
                                      </div>
                                    </div>

                                    <div className="col-md-12">
                                      <div className="text-right">
                                        <label>
                                          <FormCheck
                                            disabled={!data.clinic_name}
                                            id={`checkbox-clinic-${index}`}
                                            type="checkbox"
                                            label="Use this as mailing address"
                                            checked={
                                              data.clinic_mailing_address === 1
                                                ? true
                                                : false
                                            }
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                const updatedClinicAddress =
                                                  clinicAddress.map((addr) => ({
                                                    ...addr,
                                                    clinic_mailing_address: 0,
                                                  }));
                                                updatedClinicAddress[
                                                  index
                                                ].clinic_mailing_address = 1;
                                                setClinicAddress(
                                                  updatedClinicAddress
                                                );
                                                handleInputChange(
                                                  "mailing_address",
                                                  0
                                                );
                                              } else {
                                                handleClinicAddressChange(
                                                  index,
                                                  "clinic_mailing_address",
                                                  0
                                                );
                                              }
                                            }}
                                          />
                                        </label>
                                      </div>
                                    </div>
                                  </>
                                ))}
                              </>
                            )}

                            <div className="col-md-12 pt-3">
                              <div>
                                <button
                                  onClick={handlePersonalDInsert}
                                  className="btn btn-outline-success btn-block saveand_proced_button"
                                  type="button"
                                  disabled={isLoadingPersonal}
                                >
                                  {isLoadingPersonal ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="ms-2">
                                        Processing...
                                      </span>
                                    </>
                                  ) : (
                                    "Save & Proceed"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </Tab>
                      <Tab
                        eventKey="Education"
                        // title="Education & Practice"
                        // tabClassName="form_wizard_tab"
                        title={<span className="step-label"><span className="step-number">3</span><span className="step-text">Education & Practice</span></span>}
                        tabClassName="stepper-tab"
                      >
                        <fieldset>
                          <div className="row clearfix">
                            <div className="col-md-12">
                              <div className="header">
                                <h2>Education & Practice </h2>
                              </div>
                            </div>

                            {[1, 2, 4, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <>
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <label>
                                        Under Graduation{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-md-6 ">
                                    <div className="row">
                                      <div className="col-lg-6 col-md-12">
                                        <div className="form-group pos_relative">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              errors.edu_undergrad_college
                                                ? "red_border"
                                                : ""
                                            }`}
                                            value={
                                              formValues.edu_undergrad_college
                                            }
                                            placeholder="College"
                                            onChange={(e) =>
                                              handleInputChange(
                                                "edu_undergrad_college",
                                                e.target.value
                                              )
                                            }
                                          />
                                          {errors && (
                                            <p className="text-danger pos_abos white_space">
                                              {errors.edu_undergrad_college}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-12">
                                        <div className="form-group pos_relative">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              errors.edu_undergrad_university
                                                ? "red_border"
                                                : ""
                                            }`}
                                            value={
                                              formValues.edu_undergrad_university
                                            }
                                            placeholder="University"
                                            onChange={(e) =>
                                              handleInputChange(
                                                "edu_undergrad_university",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-12 personal_details_dropdown">
                                    <div className="form-group pos_relative">
                                      <div className="multiselect_div">
                                        <CustomDropdown
                                          dropdownData={yearData}
                                          dropdownValue={
                                            formValues.edu_undergrad_year
                                          }
                                          ShouldValidate={false}
                                          textboxError={true}
                                          setDropdownValue={(value) =>
                                            setFormValues({
                                              ...formValues,
                                              edu_undergrad_year: value,
                                            })
                                          }
                                          name="year"
                                          DataRefechRetrigger={
                                            DataRefechRetrigger
                                          }
                                          fieldName="edu_undergrad_year"
                                          errors={errors}
                                          formValues={formValues}
                                          eventType={
                                            eventType === "Update"
                                              ? "Update"
                                              : "Add"
                                          }
                                          FeildName={"edu_undergrad_year"}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <>
                                <div className="col-lg-3 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      Post Graduation{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            errors.edu_postgrad_degree
                                              ? "red_border"
                                              : ""
                                          }`}
                                          value={formValues.edu_postgrad_degree}
                                          placeholder="Degree"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_postgrad_degree",
                                              e.target.value
                                            )
                                          }
                                        />
                                        {errors && (
                                          <p className="text-danger pos_abos white_space">
                                            {errors.edu_postgrad_degree}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            errors.edu_postgrad_college
                                              ? "red_border"
                                              : ""
                                          }`}
                                          value={
                                            formValues.edu_postgrad_college
                                          }
                                          placeholder="College"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_postgrad_college",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            errors.edu_postgrad_university
                                              ? "red_border"
                                              : ""
                                          }`}
                                          value={
                                            formValues.edu_postgrad_university
                                          }
                                          placeholder="University"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_postgrad_university",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={yearData}
                                        dropdownValue={
                                          formValues.edu_postgrad_year
                                        }
                                        ShouldValidate={false}
                                        textboxError={true}
                                        setDropdownValue={(value) =>
                                          setFormValues({
                                            ...formValues,
                                            edu_postgrad_year: value,
                                          })
                                        }
                                        name="year"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        fieldName="edu_postgrad_year"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"edu_postgrad_year"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <>
                                <div className="col-lg-3 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>Super Speciality</label>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            formValues.edu_superspecialty_degree
                                          }
                                          placeholder="Degree"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_superspecialty_degree",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            formValues.edu_superspecialty_college
                                          }
                                          placeholder="College"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_superspecialty_college",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12">
                                      <div className="form-group pos_relative">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            formValues.edu_superspecialty_university
                                          }
                                          placeholder="University"
                                          onChange={(e) =>
                                            handleInputChange(
                                              "edu_superspecialty_university",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={yearData}
                                        dropdownValue={
                                          formValues.edu_superspecialty_year
                                        }
                                        setDropdownValue={(value) =>
                                          setFormValues({
                                            ...formValues,
                                            edu_superspecialty_year: value,
                                          })
                                        }
                                        name="year"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        fieldName="edu_superspecialty_year"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"edu_superspecialty_year"}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-12"></div>
                              </>
                            )}
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>
                                    NMC/State Medical Council number{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      errors.mci_council_number
                                        ? "red_border"
                                        : ""
                                    }`}
                                    value={formValues.mci_council_number}
                                    onChange={(e) => {
                                      let input = e.target.value;
                                      input = input.replace(
                                        /[^A-Za-z0-9]/g,
                                        ""
                                      ); 
                                      handleInputChange(
                                        "mci_council_number",
                                        input
                                      );
                                    }}
                                  />
                                  <small>
                                    (Only numbers and alphabetic characters are
                                    allowed.)
                                  </small>
                                  {errors && (
                                    <p className="text-danger pos_abos">
                                      {errors.mci_council_number}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                            {[1, 2, 4, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <label>
                                      NMC State{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={asiMciStateData}
                                        dropdownValue={
                                          formValues.mci_council_state
                                        }
                                        setDropdownValue={(value) =>
                                          setFormValues({
                                            ...formValues,
                                            mci_council_state: value,
                                          })
                                        }
                                        name="NMC Council State"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        fieldName="mci_council_state"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"common"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            {[1, 2, 4, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>IMR Registration Number</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={formValues.imr_reg_no}
                                      onChange={(e) => {
                                        let input = e.target.value;
                                        input = input.replace(
                                          /[^A-Za-z0-9]/g,
                                          ""
                                        );
                                        handleInputChange("imr_reg_no", input);
                                      }}
                                    />
                                    <small>
                                      (Only numbers and alphabetic characters
                                      are allowed.)
                                    </small>
                                  </div>
                                </div>
                              )}
                            <div className="col-md-6" />
                            {[1, 5, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <label>
                                      ASI Membership Number{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        errors.asi_membership_no
                                          ? "red_border"
                                          : ""
                                      }`}
                                      value={formValues.asi_membership_no}
                                      onChange={(e) => {
                                        let input = e.target.value;
                                        input = input.replace(
                                          /[^A-Za-z0-9]/g,
                                          ""
                                        );
                                        handleInputChange(
                                          "asi_membership_no",
                                          input
                                        );
                                      }}
                                    />
                                    <small>
                                      (Only numbers and alphabetic characters
                                      are allowed.)
                                    </small>
                                    {errors && (
                                      <p className="text-danger pos_abos">
                                        {errors.asi_membership_no}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}
                            {[1, 5, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                  <div className="form-group pos_relative">
                                    <label>
                                      ASI State{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="multiselect_div">
                                      <CustomDropdown
                                        dropdownData={asiMciStateData}
                                        dropdownValue={formValues.asi_state}
                                        setDropdownValue={(value) =>
                                          setFormValues({
                                            ...formValues,
                                            asi_state: value,
                                          })
                                        }
                                        name="Asi state"
                                        DataRefechRetrigger={
                                          DataRefechRetrigger
                                        }
                                        fieldName="asi_state"
                                        errors={errors}
                                        formValues={formValues}
                                        eventType={
                                          eventType === "Update"
                                            ? "Update"
                                            : "Add"
                                        }
                                        FeildName={"common"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <div className="col-lg-6 col-md-12">
                                <label>
                                  Any other international Organisations
                                </label>
                                {organisationsData.map((org) => (
                                  <div key={org.id}>
                                    <label>
                                      <FormCheck
                                        type="checkbox"
                                        id={`checkbox-${org}`}
                                        label={org}
                                        checked={formValues.other_inter_organisation?.includes(
                                          org
                                        )}
                                        onChange={(e) =>
                                          handleOtherOrganizationChange(e, org)
                                        }
                                      />
                                    </label>
                                  </div>
                                ))}
                                {formValues.other_inter_organisation?.includes(
                                  "Others"
                                ) && (
                                  <input
                                    type="text"
                                    className={`form-control`}
                                    placeholder="Please Mention"
                                    value={
                                      formValues.other_inter_organisation_value
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        "other_inter_organisation_value",
                                        e.target.value
                                      )
                                    }
                                  />
                                )}
                              </div>
                            )}
                            {[1, 2, 3, 4, 6].includes(applicationId) && (
                              <>
                                <div className="col-md-12 pt-3">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="header">
                                        <h2>Work Experience</h2>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="text-right">
                                        <button
                                          onClick={() => addProceduresField()}
                                          type="button"
                                          className="btn btn-outline-success mb-2 mr-1 "
                                        >
                                          <i className="fa fa-plus" />{" "}
                                          <span>Add New</span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <p>Position</p>
                                    </div>
                                    <div className="col-md-3">
                                      <p>Experience (From)</p>
                                    </div>
                                    <div className="col-md-3">
                                      <p>Experience (To)</p>
                                    </div>
                                    <div className="col-md-3">
                                      <p>Experience (Years)</p>
                                    </div>
                                  </div>
                                </div>
                                {procedures.map((data, index) => (
                                  <>
                                    <div className="col-md-12">
                                      <div className="row pos_rel_fielsclear">
                                        <div className="col-lg-3 col-md-12">
                                          <div className="form-group pos_relative">
                                            <input
                                              type="text"
                                              className={`form-control ${
                                                proceduresErrors[
                                                  `work_procedure-${index}`
                                                ]
                                                  ? "red_border"
                                                  : ""
                                              }`}
                                              value={data.work_procedure}
                                              onChange={(e) =>
                                                handleProceduresChange(
                                                  index,
                                                  "work_procedure",
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {proceduresErrors[
                                              `work_procedure-${index}`
                                            ] && (
                                              <p className="text-danger pos_abos">
                                                {
                                                  proceduresErrors[
                                                    `work_procedure-${index}`
                                                  ]
                                                }
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-lg-3 col-md-12">
                                          <div className="form-group pos_relative">
                                            <Datepicker
                                              selectedDate={
                                                data.no_of_procedures1
                                                  ? new Date(
                                                      data.no_of_procedures1
                                                    )
                                                  : null
                                              }
                                              onDateChange={(date) => {
                                                const formattedDate = date
                                                  ? dayjs(date).format(
                                                      dateFormatList
                                                    )
                                                  : "";
                                                handleProceduresChange(
                                                  index,
                                                  "no_of_procedures1",
                                                  formattedDate
                                                );
                                              }}
                                              className={`form-control ${
                                                proceduresErrors[
                                                  `no_of_procedures1-${index}`
                                                ]
                                                  ? "red_border"
                                                  : ""
                                              }`}
                                              placeholder="DD/MM/YYYY"
                                            />
                                            {proceduresErrors[
                                              `no_of_procedures1-${index}`
                                            ] && (
                                              <p className="text-danger pos_abos">
                                                {
                                                  proceduresErrors[
                                                    `no_of_procedures1-${index}`
                                                  ]
                                                }
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-lg-3 col-md-12">
                                          <div className="form-group pos_relative">
                                            <Datepicker
                                              selectedDate={
                                                data.no_of_procedures2
                                                  ? new Date(
                                                      data.no_of_procedures2
                                                    )
                                                  : null
                                              }
                                              onDateChange={(date) => {
                                                const formattedDate = date
                                                  ? dayjs(date).format(
                                                      dateFormatList
                                                    )
                                                  : "";
                                                handleProceduresChange(
                                                  index,
                                                  "no_of_procedures2",
                                                  formattedDate
                                                );
                                              }}
                                              className={`form-control ${
                                                proceduresErrors[
                                                  `no_of_procedures2-${index}`
                                                ]
                                                  ? "red_border"
                                                  : ""
                                              }`}
                                              placeholder="DD/MM/YYYY"
                                            />
                                            {proceduresErrors[
                                              `no_of_procedures2-${index}`
                                            ] && (
                                              <p className="text-danger pos_abos">
                                                {
                                                  proceduresErrors[
                                                    `no_of_procedures2-${index}`
                                                  ]
                                                }
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-lg-2 col-md-12">
                                          <div className="form-group pos_relative wid_input_half">
                                            <input
                                              type="number"
                                              className={`form-control`}
                                              value={workExpInYears(
                                                data.no_of_procedures1,
                                                data.no_of_procedures2
                                              )}
                                              disabled
                                              onChange={(e) =>
                                                handleProceduresChange(
                                                  index,
                                                  "no_of_procedures2",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-lg-1 col-md-12 text-end">
                                          <div
                                            onClick={() =>
                                              removeProceduresField(
                                                index,
                                                data.id
                                              )
                                            }
                                            className="btn btn-danger mb-2 mr-1 "
                                            type="button"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ))}
                              </>
                            )}
                            <div className="col-md-12">
                              <div className="header">
                                <h2>Documents</h2>
                              </div>
                            </div>
                            {[1, 2, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-md-12 col-12  pos_relative">
                                  <div className="dropdown_cetifica_div">
                                    <label>
                                      NMC Certificate{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <br />
                                    <small>
                                      (Maximum file size allowed: 2MB ){" "}
                                      <span>
                                        Kindly do not upload password-protected
                                        pdf's
                                      </span>{" "}
                                    </small>
                                  </div>
                                  <SingleFileUpload
                                    onFileUpload={handleMciCertificateUpload}
                                    setFileError={setMciCertificateError}
                                    fileError={mciCertificateError}
                                  />
                                  {errors && (
                                    <p className="text-danger pos_abos left_15">
                                      {errors.mci_certificate}
                                    </p>
                                  )}
                                  <div className="width-fit view_button_list_pos">
                                    {memberDetails.mci_certificate &&
                                      !mciCertificateFile && (
                                        <a
                                          href={`${memberDetails.mci_certificate}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-outline-info btn-block"
                                        >
                                          View Document
                                        </a>
                                      )}
                                  </div>
                                </div>
                              )}
                            {([1, 2, 3, 6].includes(applicationId) ||
                              `${formValues.country}` !== "101") && (
                              <div className="col-md-12 col-12  pos_relative">
                                <div className="dropdown_cetifica_div">
                                  <label>
                                    PG Degree Certificate{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <small>
                                    (Maximum file size allowed: 2MB ){" "}
                                    <span>
                                      Kindly do not upload password-protected
                                      pdf's
                                    </span>{" "}
                                  </small>
                                </div>
                                <SingleFileUpload
                                  onFileUpload={handlePgDegreeCertificateUpload}
                                  setFileError={setPgDegreeCertificateError}
                                  fileError={pgDegreeCertificateError}
                                />
                                {errors && (
                                  <p className="text-danger pos_abos left_15">
                                    {errors.pg_degree_certificate}
                                  </p>
                                )}
                                <div className="width-fit view_button_list_pos">
                                  {" "}
                                  {!pgDegreeCertificateFile &&
                                    memberDetails.pg_degree_certificate && ( //22-02 bhrathi
                                      <a
                                        href={`${memberDetails.pg_degree_certificate}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block"
                                      >
                                        View Document
                                      </a>
                                    )}
                                </div>
                              </div>
                            )}
                            {[1, 5, 6].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-md-12 col-12  pos_relative">
                                  <div className="dropdown_cetifica_div">
                                    <label>
                                      ASI Membership Certificate{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <br />
                                    <small>
                                      (Maximum file size allowed: 2MB ){" "}
                                      <span>
                                        Kindly do not upload password-protected
                                        pdf's
                                      </span>{" "}
                                    </small>
                                  </div>
                                  <SingleFileUpload
                                    onFileUpload={
                                      handleAsiMemberCertificateUpload
                                    }
                                    setFileError={setAsiMemberCertificateError}
                                    fileError={asiMemberCertificateError}
                                  />
                                  {errors && (
                                    <p className="text-danger pos_abos left_15">
                                      {errors.asi_member_certificate}
                                    </p>
                                  )}
                                  <div className="width-fit view_button_list_pos">
                                    {memberDetails.asi_member_certificate &&
                                      !asiMemberCertificateFile && (
                                        <a
                                          href={`${memberDetails.asi_member_certificate}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-outline-info btn-block"
                                        >
                                          View Document
                                        </a>
                                      )}
                                  </div>
                                </div>
                              )}
                            {([3].includes(applicationId) ||
                              `${formValues.country}` !== "101") && (
                              <div className="col-md-12 col-12  pos_relative">
                                <div className="dropdown_cetifica_div">
                                  <label>
                                    Active License for Practicing Surgeons{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <small>
                                    (Maximum file size allowed: 2MB ){" "}
                                    <span>
                                      Kindly do not upload password-protected
                                      pdf's
                                    </span>{" "}
                                  </small>
                                </div>
                                <SingleFileUpload
                                  onFileUpload={handleActiveLicenseUpload}
                                  setFileError={setActiveLicenseError}
                                  fileError={activeLicenseError}
                                />
                                {errors && (
                                  <p className="text-danger pos_abos left_15">
                                    {errors.active_license}
                                  </p>
                                )}
                                <div className="width-fit view_button_list_pos">
                                  {memberDetails.active_license && // 22-02 Bharathi
                                    !activeLicenseFile && (
                                      <a
                                        href={`${memberDetails.active_license}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info btn-block"
                                      >
                                        View Document
                                      </a>
                                    )}
                                </div>
                              </div>
                            )}
                            {[4].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-md-12 col-12  pos_relative">
                                  <div className="dropdown_cetifica_div">
                                    <label>
                                      Letter from HOD{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <br />
                                    <small>
                                      (Maximum file size allowed: 2MB ){" "}
                                      <span>
                                        Kindly do not upload password-protected
                                        pdf's
                                      </span>{" "}
                                    </small>
                                  </div>
                                  <SingleFileUpload
                                    onFileUpload={handleHodLetterUpload}
                                    setFileError={setHodLetterError}
                                    fileError={hodLetterError}
                                  />
                                  {errors && (
                                    <p className="text-danger pos_abos left_15">
                                      {errors.letter_hod}
                                    </p>
                                  )}
                                  <div className="width-fit view_button_list_pos">
                                    {memberDetails.letter_hod &&
                                      !hodLetterFile && (
                                        <a
                                          href={`${memberDetails.letter_hod}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-outline-info btn-block"
                                        >
                                          View Document
                                        </a>
                                      )}
                                  </div>
                                </div>
                              )}
                            {[4].includes(applicationId) &&
                              `${formValues.country}` === "101" && (
                                <div className="col-md-12 col-12  pos_relative">
                                  <div className="dropdown_cetifica_div">
                                    <label>
                                      MBBS Degree certificate{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <br />
                                    <small>
                                      (Maximum file size allowed: 2MB ){" "}
                                      <span>
                                        Kindly do not upload password-protected
                                        pdf's
                                      </span>{" "}
                                    </small>
                                  </div>
                                  <SingleFileUpload
                                    onFileUpload={
                                      handleMbbsDegreeCertificateUpload
                                    }
                                    setFileError={setMbbsDegreeCertificateError}
                                    fileError={mbbsDegreeCertificateError}
                                  />
                                  {errors && (
                                    <p className="text-danger   pos_abos left_15">
                                      {errors.mbbs_degree_certificate}
                                    </p>
                                  )}
                                  <div className="width-fit view_button_list_pos">
                                    {memberDetails.mbbs_degree_certificate &&
                                      !mbbsDegreeCertificateFile && (
                                        <a
                                          href={`${memberDetails.mbbs_degree_certificate}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-outline-info btn-block"
                                        >
                                          View Document
                                        </a>
                                      )}
                                  </div>
                                </div>
                              )}
                            <div className="col-md-12 pt-5">
                              <div className="last_form_submit_flex">
                                <div>
                                  <button
                                    onClick={handlePrevTab}
                                    className="btn  btn-danger btn-block saveand_proced_button"
                                    type="button"
                                  >
                                    Back
                                  </button>
                                </div>
                                <div>
                                  <button
                                    onClick={handleInsertEduData}
                                    className="btn btn-outline-success btn-block saveand_proced_button"
                                    type="button"
                                    disabled={isLoadingEducation}
                                  >
                                    {isLoadingEducation ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span className="ms-2">
                                          Processing...
                                        </span>
                                      </>
                                    ) : (
                                      "Save Proceed"
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </Tab>
                      <Tab
                        eventKey="Review"
                        // title="Review & Submit"
                        // tabClassName="form_wizard_tab"
                        title={<span className="step-label"><span className="step-number">4</span><span className="step-text">Review & Submit</span></span>}
                        tabClassName="stepper-tab"
                      >
                        <fieldset>
                          {activeTab === "Review" && (
                            <UserViewMembershipApplicationComponent
                              page={"review"}
                              memberId={userOTPid}
                              handlePrevTab={handlePrevTab}
                              handlePayment={handlePayment}
                            />
                          )}
                        </fieldset>
                      </Tab>
                    </Tabs>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade bd-example-modal-lg ${
            isConfirmModal ? "d-block show" : ""
          }`}
          onClick={() => setIsConfirmModal(false)}
        >
          <div
            className="modal-dialog modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title h4" id="myLargeModalLabel">
                  You Have already Registered
                </h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={() => setIsConfirmModal(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div>
                  <p>
                    You already have another incomplete application associated
                    with your email id- {formValues.email}. Do you wish to
                    continue with the old application or do you want to create a
                    fresh application?
                  </p>
                </div>

                <div className="otp_button_div pt-4">
                  <div>
                    <button
                      className="btn btn-outline-info btn-block"
                      type="button"
                      onClick={handleCreateFresh}
                    >
                      CREATE FRESH APPLICATION
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-outline-primary btn-block"
                      type="button"
                      onClick={handleContinueWithOld} // Trigger continuation with old application
                    >
                      CONTINUE WITH OLD APPLICATION
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade bd-example-modal-lg ${
            isModalOpen ? "d-block show" : ""
          }`}
          style={{
            backgroundColor: isModalOpen ? "rgba(0, 0, 0, 0.5)" : "transparent",
          }}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title h4" id="myLargeModalLabel">
                  Email Verification
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModalOpen(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div>
                  <p>Enter the 4-digit code sent to {formValues.email}</p>
                </div>
                {/* OTP Expiry Timer */}
                <div className="otp-timer mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1 text_cap">
                    <span>Code expires in:</span>
                    <span>{formatTime(otpExpiryTime)}</span>
                  </div>
                  <div className="progress" style={{ height: "4px" }}>
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{
                        width: `${calculateProgress(otpExpiryTime, 180)}%`,
                      }}
                      aria-valuenow={otpExpiryTime}
                      aria-valuemin="0"
                      aria-valuemax="180"
                    ></div>
                  </div>
                </div>
                <div className="otp_flex_front">
                  {Object.keys(otp).map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      id={digit}
                      className="form-control"
                      placeholder=""
                      aria-label={`OTP ${index + 1}`}
                      value={otp[digit]}
                      onChange={(e) => handleOtpChange(e, digit)}
                      maxLength={1}
                    />
                  ))}
                </div>
                <div className="bottom d-flex justify-content-between align-items-center">
                  <span className="helper-text">
                    Check your inbox & spam folder
                  </span>
                  <span className="helper-text">
                    <button
                      onClick={handleResendOTP}
                      className="btn btn-link"
                      type="button"
                      disabled={!canResend && resendTime > 0}
                    >
                      {canResend ? "Resend OTP" : `Resend in ${resendTime}s`}
                    </button>
                  </span>
                </div>
                <div className="otp_button_div pt-4">
                  {/* <div>
                    <button
                      className="btn btn-outline-info btn-block"
                      type="button"
                      onClick={handleResendOTP}
                    >
                      Resend OTP
                    </button>
                  </div> */}
                  <div>
                    <button
                      className="btn btn-outline-primary btn-block"
                      type="button"
                      onClick={hanldeOTPVerify}
                      disabled={!isOtpComplete}
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* login model */}
        <div
          className={`login_details_popup modal fade ${
            loginModal ? "d-block show" : ""
          }`}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content rounded-4 shadow">
              <div className="modal-body">
                <div className="pb-2">
                  <h5 className="modal-title fw-bold">
                    Email Already Registered
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => handleLoginModalClose()}
                  >
                    <IoMdClose size={18} />
                  </button>
                </div>
                <div className="pb-2">
                  <p>
                    The email address <strong>{formValues.email}</strong> is
                    already associated with an account. Please choose one of the
                    following options:
                  </p>
                </div>
                <div className="form-group position-relative mb-3">
                  <label>Email</label>
                  <FaEnvelope className="form-icon" />
                  <input
                    type="email"
                    className="form-control ps-5"
                    value={formValues.email}
                    readOnly
                    disabled
                  />
                </div>
                <div className="form-group position-relative mb-3">
                  <label className="forget_flex">
                    Password
                    <Link
                      to={`${ROUTE_BASE_URL}/user-forgot-password`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="float-end text-decoration-none"
                    >
                      Forgot password?
                    </Link>
                  </label>
                  <FaLock className="form-icon" />
                  <input
                    type="password"
                    className={`form-control ${
                      loginPasswordError ? "red_border" : ""
                    } ps-5`}
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                  />
                  {loginPasswordError && (
                    <p className="text-danger pos_abos">{loginPasswordError}</p>
                  )}
                </div>
              </div>
              <div className="pl-3 pr-3">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={() => handleLogin()}
                >
                  Login and Continue <FaArrowRight />
                </button>
              </div>
              <div className="modal-footer border-0 d-flex justify-content-between">
                <p>
                  {" "}
                  <i class="fa fa-question-circle" /> Need Help
                </p>
                <button
                  type="button"
                  className="btn btn-outline-default"
                  onClick={() => handleLoginModalClose()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </div>
  );
};

export default UserMemberApplication;
